/* Fun Cases personaliser — canvas editor (Fabric.js, lazy-loaded).
   Model: an ARTBOARD = print area + bleed. Content lives on the artboard; a
   mockup overlay (transparent print window) frames it, so anything spilling off
   the case is captured as bleed. Fabric loads only when the editor first opens.

   Config (per product) comes from window.__fcPersonalise:
     { productFormSelector, fabricUrl, aspect, bleed, mockup, radius,
       fonts:[], colours:[], stickers:[] }
   Left as sensible defaults until real per-product masks/config are wired. */
(function () {
  'use strict';

  var CFG = window.__fcPersonalise || {};
  var AW = 1000;                                   // internal artboard width
  var ASPECT = CFG.aspect || 0.5;                  // print area w/h
  var AH = Math.round(AW / ASPECT);                // internal artboard height
  var MODE = 'overlay';                            // 'overlay' (transparent window) | 'print' (garment behind)
  var PIPE = 'placed';                             // active finish pipeline: 'phone' | 'placed' | 'flat'
  var PRINT = null;                                // print area [x,y,w,h] as fractions of the artboard
  var FRAMEFIT = 0;                                // >0 = scale base design by the composite frame math (case height fraction)
  var baseLoaded = false;                          // standard designs pre-load their AWS artwork once
  var BLEED = CFG.bleed != null ? CFG.bleed : 0.05;
  var RADIUS = CFG.radius != null ? CFG.radius : 0.09; // corner radius (of AW)
  var FONTS = CFG.fonts || ['Fredoka', 'Nunito', 'Le Petit Cochon', 'Georgia', 'Impact', 'Courier New'];
  var COLOURS = CFG.colours || ['#161616', '#ffffff', '#f03e2e', '#ffc933', '#35bdf2', '#58bb46', '#ff7bb2', '#8a4fd3'];
  var STICKERS = CFG.stickers || ['⭐', '❤️', '🌈', '✨', '🌸', '💀', '🍒', '😎', '👑', '🦋', '☀️', '⚡', '🍄', '🎀', '🐾'];

  var modal, canvasEl, fcanvas, fabricReady = false, loadingFabric = false;
  var activeColour = COLOURS[0], activeFont = FONTS[0];
  var history = [], histIdx = -1, restoring = false;
  var introShown = false;
  var designAttached = false;
  // Which plate the current design was actually built on. Colour Sides can change AFTER the design
  // is finished, and the plate differs per material, so we have to know what we used.
  var pzPlateSrc = null, pzPlateSide = null;

  /* ---------- open / close ---------- */
  function open() {
    if (!modal) build();
    document.body.classList.add('pz-lock');
    modal.classList.add('is-open');
    modal.classList.toggle('pz--phone', !!(CFG.isPhone && CFG.baseDesignRaw));
    if (!introShown) { var iv = modal.querySelector('[data-pz-intro]'); if (iv) iv.hidden = false; }
    ensureFabric(function () {
      if (!fcanvas) initCanvas(); else applyEntry();
      // Template products open straight onto their slot form; everything else keeps the tool rail.
      if (CFG.template) tplBuildPanel();
      else if (window.innerWidth >= 900) switchTab('photo');
      fitBoard();
      hint('Tap a tool to start');
    });
  }
  function close() { if (!modal) return; modal.classList.remove('is-open'); document.body.classList.remove('pz-lock'); }

  /* ---------- lazy-load fabric ---------- */
  function ensureFabric(cb) {
    if (fabricReady && window.fabric) return cb();
    if (loadingFabric) { var t = setInterval(function () { if (window.fabric) { clearInterval(t); fabricReady = true; cb(); } }, 60); return; }
    loadingFabric = true;
    var s = document.createElement('script');
    s.src = CFG.fabricUrl;
    s.onload = function () { fabricReady = true; cb(); };
    s.onerror = function () { loading(false); alert('Could not load the designer. Please refresh and try again.'); };
    document.head.appendChild(s);
  }

  /* ---------- build DOM ---------- */
  function icon(paths) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + paths + '</svg>';
  }
  function build() {
    modal = document.createElement('div');
    modal.className = 'pz';
    modal.innerHTML =
      '<div class="pz__inner">' +
        '<div class="pz__top">' +
          '<button class="pz__x" data-pz-close aria-label="Close">' + icon('<path d="M6 6l12 12M18 6L6 18"/>') + '</button>' +
          '<div class="pz__title">Make it yours</div>' +
          '<div class="pz__undo">' +
            '<button class="pz__iconbtn" data-pz-undo aria-label="Undo" disabled>' + icon('<path d="M9 14 4 9l5-5"/><path d="M4 9h11a5 5 0 0 1 0 10h-3"/>') + '</button>' +
          '</div>' +
        '</div>' +
        '<div class="pz__stage">' +
          '<div class="pz__obj" data-pz-objbar>' +
            '<button data-pz-forward aria-label="Bring forward">' + icon('<path d="M12 5v14M5 12l7-7 7 7"/>') + '</button>' +
            '<button data-pz-dup aria-label="Duplicate">' + icon('<rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/>') + '</button>' +
            '<button class="danger" data-pz-del aria-label="Delete">' + icon('<path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/>') + '</button>' +
          '</div>' +
          '<div class="pz__board"><canvas data-pz-canvas></canvas></div>' +
          '<div class="pz__hint" data-pz-hint></div>' +
          '<div class="pz__loading" data-pz-loading><span class="pz__spin"></span><span class="pz__loadmsg" data-pz-loadmsg></span></div>' +
        '</div>' +
        '<div class="pz__controls">' +
        '<div class="pz__panels">' +
          '<div class="pz__panel" data-pz-panel="photo">' +
            '<label class="pz-upload"><span class="pz-upload__ico">📷</span><b>Upload a photo</b><span>JPG or PNG, up to 15MB</span>' +
              '<input type="file" accept="image/*" data-pz-file></label>' +
          '</div>' +
          '<div class="pz__panel" data-pz-panel="text">' +
            '<div class="pz__field"><input type="text" placeholder="Type here…" data-pz-text maxlength="60"><button class="pz__add" data-pz-addtext>Add</button></div>' +
            '<div class="pz__row"><span class="lbl">Font</span><div class="pz-fonts" data-pz-fonts></div></div>' +
            '<div class="pz__row"><span class="lbl">Colour</span><div class="pz-swatches" data-pz-swatches></div></div>' +
          '</div>' +
          '<div class="pz__panel" data-pz-panel="stickers">' +
            '<div class="pz-stickers" data-pz-stickers></div>' +
          '</div>' +
        '</div>' +
        '<div class="pz__bar">' +
          '<button class="pz-tab" data-pz-tab="photo">' + icon('<rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="11" r="2"/><path d="m21 17-5-5-8 7"/>') + '<span>Photo</span></button>' +
          '<button class="pz-tab" data-pz-tab="text">' + icon('<path d="M4 7V5h16v2M9 5v14M7 19h4"/>') + '<span>Text</span></button>' +
          '<button class="pz-tab" data-pz-tab="stickers">' + icon('<path d="M15 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9l7-7V5a2 2 0 0 0-2-2Z"/><path d="M14 21v-5a2 2 0 0 1 2-2h5"/>') + '<span>Stickers</span></button>' +
          '<button class="pz-done" data-pz-done><span data-pz-done-label>Done</span></button>' +
        '</div>' +
        '</div>' +
        '<div class="pz__intro" data-pz-intro hidden>' +
          '<div class="pz__intro-card">' +
            '<div class="pz__intro-spark">✨</div>' +
            '<h3>Before you start</h3>' +
            '<ul class="pz__intro-list">' +
              '<li><span>📐</span><p><b>Keep the important bits away from the edges.</b> Printing can shift a millimetre or two, so faces, text and logos near the border may get trimmed.</p></li>' +
              '<li><span>🎁</span><p><b>Personalised items are made just for you</b>, so they can\'t be returned or refunded. Give your design a good look before you add to bag.</p></li>' +
              '<li><span>🛒</span><p><b>Your design is only saved once you add to bag.</b> If you change your phone or options beforehand, the design will reset — so finish designing, then add to bag.</p></li>' +
            '</ul>' +
            '<button type="button" class="pz__intro-ok" data-pz-intro-ok>Got it — let\'s design</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    // populate swatches / fonts / stickers
    var sw = modal.querySelector('[data-pz-swatches]');
    COLOURS.forEach(function (c, i) {
      var b = document.createElement('button');
      b.className = 'pz-sw' + (i === 0 ? ' is-active' : ''); b.style.background = c; b.dataset.col = c;
      sw.appendChild(b);
    });
    var fw = modal.querySelector('[data-pz-fonts]');
    FONTS.forEach(function (f, i) {
      var b = document.createElement('button');
      b.className = 'pz-font' + (i === 0 ? ' is-active' : ''); b.textContent = f.replace(/'/g, ''); b.style.fontFamily = f; b.dataset.font = f;
      fw.appendChild(b);
    });
    var stk = modal.querySelector('[data-pz-stickers]');
    STICKERS.forEach(function (s) {
      var b = document.createElement('button');
      b.className = 'pz-sticker'; b.textContent = s; b.dataset.sticker = s;
      stk.appendChild(b);
    });

    canvasEl = modal.querySelector('[data-pz-canvas]');
    wireEvents();
  }

  function loading(on, msg) { var el = modal && modal.querySelector('[data-pz-loading]'); if (!el) return; el.style.display = on ? 'flex' : 'none'; var m = el.querySelector('[data-pz-loadmsg]'); if (m) m.textContent = on && msg ? msg : ''; }
  // Lower-cased product type for use mid-sentence: 'Phone Case' -> 'phone case'.
  function productNoun() {
    var t = (CFG.productType || '').trim().toLowerCase();
    return t || 'design';
  }
  function hint(msg) { var el = modal.querySelector('[data-pz-hint]'); if (!el) return; el.textContent = msg; el.classList.add('show'); clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('show'); }, 2200); }

  /* ---------- canvas ---------- */
  function initCanvas() {
    // controlsAboveOverlay: a flat-mask product sets fcanvas.clipPath to the plate, and Fabric 5.3's
    // renderCanvas paints controls BEFORE drawClipPathOnCanvas, which composites with
    // 'destination-in' — so anything outside the mask, controls included, was erased. A photo
    // larger than the mask therefore had no visible resize or rotate handles at all. Drawing the
    // controls after the clip keeps them reachable outside the print area even though the image
    // itself is still correctly clipped to it.
    fcanvas = new fabric.Canvas(canvasEl, { selection: true, preserveObjectStacking: true, controlsAboveOverlay: true, backgroundColor: '#ffffff' });
    fabric.Object.prototype.set({ cornerColor: '#161616', cornerStyle: 'circle', cornerSize: 22, touchCornerSize: 40, transparentCorners: false, borderColor: '#35bdf2', borderScaleFactor: 2, padding: 4 });

    applyEntry();

    // fitView on selection, fitBoard on deselect: an object overhanging the board is zoomed into
    // view so its handles are reachable, and the case returns to full size the moment it is
    // deselected. Ordering matters — updateObjBar positions the floating toolbar from screen
    // coordinates, so the viewport must settle first or the bar lands where the object WAS.
    fcanvas.on('selection:created', function (e) { fitView(); updateObjBar(e); });
    fcanvas.on('selection:updated', function (e) { fitView(); updateObjBar(e); });
    fcanvas.on('selection:cleared', function (e) { fitBoard(); updateObjBar(e); });
    fcanvas.on('object:moving', constrainObj);
    fcanvas.on('object:modified', snapshot);
    enablePinchScale();
    snapshot();
  }
  // Two-finger pinch to resize the selected element on touch devices (the corner handles are
  // fiddly on a phone). Scales the active object only — never the canvas viewport, so exports
  // are unaffected. No-op with nothing selected or on the locked base design.
  function enablePinchScale() {
    var el = fcanvas && fcanvas.upperCanvasEl; if (!el) return;
    var startDist = 0, startScale = 1, target = null;
    function d(t) { var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.sqrt(dx * dx + dy * dy); }
    el.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 2) return;
      var o = fcanvas.getActiveObject();
      if (o && !o._pzBase && !o._pzGuide) { target = o; startDist = d(e.touches); startScale = o.scaleX || 1; o.lockMovementX = o.lockMovementY = true; }
    }, { passive: true });
    el.addEventListener('touchmove', function (e) {
      if (!target || e.touches.length !== 2 || !startDist) return;
      e.preventDefault();
      var s = Math.max(0.05, Math.min(startScale * (d(e.touches) / startDist), 8));
      target.scale(s); target.setCoords(); fcanvas.requestRenderAll();
    }, { passive: false });
    function endPinch(e) {
      if (e.touches && e.touches.length >= 2) return;
      if (target) { target.lockMovementX = target.lockMovementY = false; snapshot(); }
      target = null; startDist = 0;
    }
    el.addEventListener('touchend', endPinch);
    el.addEventListener('touchcancel', endPinch);
  }

  // The print-area rectangle in artboard pixels (from PRINT fractions, else full board minus bleed).
  function printRectPx() {
    if (PRINT) return { left: AW * PRINT[0], top: AH * PRINT[1], width: AW * PRINT[2], height: AH * PRINT[3] };
    var bx = AW * BLEED, by = AH * BLEED;
    return { left: bx, top: by, width: AW - bx * 2, height: AH - by * 2 };
  }
  // Draw the guide: dashed rounded trim for overlay (phone), a solid print box for print mode (garment).
  function drawGuides() {
    if (fcanvas.clipPath) { fcanvas.getObjects().filter(function (o) { return o._pzGuide && o._pzGuideRect; }).forEach(function (o) { fcanvas.remove(o); }); return; }
    fcanvas.getObjects().filter(function (o) { return o._pzGuide; }).forEach(function (o) { fcanvas.remove(o); });
    // Phones: the case itself is the boundary (the view is cropped to it), so no dashed guide.
    // (Custom/Design-Your-Own phones have no baseDesignRaw but are still phones — the case mockup
    // is the boundary, so they must NOT get the stray dashed trim either.)
    if (CFG.isPhone) return;
    var p = printRectPx();
    var guide = new fabric.Rect({
      left: p.left, top: p.top, width: p.width, height: p.height,
      rx: MODE === 'print' ? 4 : AW * RADIUS, ry: MODE === 'print' ? 4 : AW * RADIUS,
      fill: MODE === 'print' ? 'rgba(88,187,70,0.05)' : 'rgba(53,189,242,0.04)',
      stroke: MODE === 'print' ? 'rgba(22,22,22,0.6)' : 'rgba(22,22,22,0.45)',
      strokeDashArray: MODE === 'print' ? [8, 6] : [10, 8], strokeWidth: 2,
      selectable: false, evented: false, excludeFromExport: true
    });
    guide._pzGuide = true;
    fcanvas.add(guide); fcanvas.sendToBack(guide);
  }
  // Clip a design object to the print area so nothing renders (or prints) outside it.
  // Applies to garments (print mode) AND phones (overlay with a case print rect).
  function clipObj(o) {
    if (!PRINT) return;
    if (CASE_HARD) {
      // Custom phones (DYO + Custom Photo): clip to the case's measured print WINDOW so
      // nothing shows through the translucent outer walls e_trim keeps in the bounds.
      // exportArt expands these clips to the full PRINT rect so prints still bleed.
      var rr = CASE_HARD.width * 0.07;
      o.clipPath = new fabric.Rect({ left: CASE_HARD.left, top: CASE_HARD.top, width: CASE_HARD.width, height: CASE_HARD.height, rx: rr, ry: rr, absolutePositioned: true });
      o._pzPrintBleed = true;
      return;
    }
    var p = printRectPx();
    o.clipPath = new fabric.Rect({ left: p.left, top: p.top, width: p.width, height: p.height, absolutePositioned: true });
  }
  // Keep a dragged object's centre inside the print area so it can't be lost off the case.
  function constrainObj(e) {
    if (!PRINT) return;
    var o = e.target; if (!o || o._pzGuide) return;
    var p = printRectPx();
    if (o.originX === 'center' && o.originY === 'center') {
      o.left = Math.max(p.left, Math.min(p.left + p.width, o.left));
      o.top = Math.max(p.top, Math.min(p.top + p.height, o.top));
    }
  }

  /* ---------- mockup (from the global map) ---------- */
  function firstVal(o) { for (var k in o) { if (o.hasOwnProperty(k)) return o[k]; } return null; }
  function currentSide() {
    var r = document.querySelector('input[name="properties[Colour Sides]"]:checked');
    if (r && r.getAttribute('data-side')) return r.getAttribute('data-side');
    return (CFG.colourSide || 'black');
  }
  // Every value currently selected on the PDP (colour sides + all variant options),
  // lowercased, so a mockup keyed by a variant dimension (colour / shape / metal) can be matched.
  function currentSelections() {
    var out = [];
    var cs = document.querySelector('input[name="properties[Colour Sides]"]:checked');
    if (cs && cs.value) out.push(cs.value.toLowerCase().trim());
    document.querySelectorAll('.pdp-option input:checked').forEach(function (c) {
      if (c.value) out.push(c.value.toLowerCase().trim());
    });
    return out;
  }
  function norm(leaf) {
    if (!leaf) return null;
    if (typeof leaf === 'string') return { url: leaf, mode: 'overlay', print: null };
    // 'placed' = spreadsheet-driven: render the design through the recipe transforms (mockup at
    // opacity 0 sets the frame) so the design lands at the exact size/position, then overlay the mockup.
    if (leaf.mode === 'placed') return { mode: 'placed', baseTransform: leaf.baseTransform, mockupLayer: leaf.mockupLayer, layerFx: leaf.layerFx || null, print: leaf.print || null };
    // 'flat' = clothing/drinkware: a plain artboard (ratio) the customer designs on; on Done the
    // artwork is uploaded and composited onto the garment/drinkware via the product recipe.
    if (leaf.mode === 'flat') return { mode: 'flat', ratio: leaf.ratio || 0.7071, preview: leaf.preview };
    if (typeof leaf.url !== 'string') return null;
    return { url: leaf.url, mode: leaf.mode || 'overlay', print: leaf.print || null, frameFit: leaf.frameFit || null };
  }
  // Config passes the product-TYPE subtree; resolve it to one { url, mode, print }.
  // Either a direct entry, or keyed by a variant value we match against the current selections.
  // Live blank from the CURRENTLY selected PDP variant's Cloudinary composite (phone
  // cases). Reads the same [data-pdp-cloud] map the product image uses, extracts the
  // baked-in case layer, and renders it alone on a transparent 1000² canvas — so the
  // popup always matches the live model + case type + colour, with no page-load staleness.
  function liveEntry() {
    if (!CFG.isPhone) return null;
    var idEl = document.querySelector('[data-pdp-variant-id]');
    var cloudEl = document.querySelector('[data-pdp-cloud]');
    if (!idEl || !cloudEl) return null;
    var cloud; try { cloud = JSON.parse(cloudEl.textContent); } catch (e) { return null; }
    var ent = cloud[idEl.value]; if (!ent) return null;
    var side = currentSide();
    var comp = ent[side] || ent.black || ent.clear || ent.white;
    if (!comp || comp.indexOf('/l_') < 0) return null;
    var lid = comp.split('/l_')[1].split(',')[0];
    if (!lid) return null;
    // e_trim crops the case to its tight phone bounds so it FILLS the editor box. frameFit:0.94
    // tells the base-design loader to scale the artwork by the composite's frame math (design
    // contained in a 1000² frame, case at h_940) so placement still matches Cloudinary exactly.
    return { url: 'https://res.cloudinary.com/dpuznvkgc/image/upload/e_trim/f_png/' + lid, mode: 'overlay', print: CFG.phonePrint || null, frameFit: 0.94 };
  }
  // Resolve just the metafield entry (type → colour/shape/metal), without the live phone composite.
  function resolveMockupEntry() {
    var m = CFG.mockups;
    if (!m) return CFG.mockup ? { url: CFG.mockup, mode: 'overlay', print: null } : null;
    if (typeof m === 'string') return { url: m, mode: 'overlay', print: null };
    if (typeof m.url === 'string' || typeof m.mode === 'string') return norm(m);  // direct entry
    var sel = currentSelections(), keys = Object.keys(m);
    for (var i = 0; i < keys.length; i++) {
      if (sel.indexOf(keys[i].toLowerCase().trim()) > -1) return norm(m[keys[i]]);   // match colour / shape / metal
    }
    var byType = m.Standard || firstVal(m);
    if (byType && typeof byType === 'object' && typeof byType.url !== 'string' && typeof byType.mode !== 'string') {
      var side = currentSide(), cap = side.charAt(0).toUpperCase() + side.slice(1);
      var leaf = byType[cap] || byType[side]; if (leaf) return norm(leaf);
    }
    return norm(firstVal(m));
  }
  // Per-model print-area aspect (width/height) for WOYC Tough / MagSafe Tough, from the Printify
  // catalog. Used so the DYO artboard matches the case's real print area → the design maps 1:1 onto
  // the case (no crop/margin) instead of the generic 0.5. Regenerate if WOYC changes the blueprints.
  var DYO_ASPECTS = {"tough":{"iPhone 18 Pro":0.5988,"iPhone 18 Pro Max":0.5886,"iPhone 17e":0.6063,"iPhone 16e":0.6063,"iPhone 17":0.5971,"iPhone 17 Air":0.5942,"iPhone 17 Pro":0.5988,"iPhone 17 Pro Max":0.5886,"iPhone 16":0.5976,"iPhone 16 Plus":0.6053,"iPhone 16 Pro":0.5976,"iPhone 16 Pro Max":0.6053,"iPhone 15":0.5976,"iPhone 15 Plus":0.6053,"iPhone 15 Pro":0.5976,"iPhone 15 Pro Max":0.6053,"iPhone 14":0.6251,"iPhone 14 Plus":0.6075,"iPhone 14 Pro":0.6262,"iPhone 14 Pro Max":0.6067,"iPhone 13":0.607,"iPhone 13 Pro":0.607,"iPhone 13 Pro Max":0.5959,"iPhone 13 Mini":0.6128,"iPhone 12 Pro Max":0.5959,"iPhone 12 Mini":0.6128,"iPhone 11":0.6263,"iPhone 11 Pro":0.6174,"iPhone 11 Pro Max":0.5978,"iPhone XS Max":0.6177,"iPhone XR":0.6276,"Galaxy S26":0.598,"Galaxy S26 Plus":0.5921,"Galaxy S26 Ultra":0.5884,"Galaxy S25":0.5966,"Galaxy S25 Plus":0.589,"Galaxy S25 Ultra":0.6056,"Galaxy S24":0.5966,"Galaxy S24 Plus":0.589,"Galaxy S24 Ultra":0.5941,"Galaxy S23":0.606,"Galaxy S23 Plus":0.6014,"Galaxy S23 Ultra":0.5946,"Galaxy S22":0.6046,"Galaxy S22 Plus":0.5945,"Galaxy S22 Ultra":0.5833,"Galaxy S21":0.5796,"Galaxy S21 Plus":0.5689,"Galaxy S21 Ultra":0.552,"Galaxy S21FE":0.5794,"Galaxy S20":0.5504,"Galaxy S20 Plus":0.5472,"Galaxy S20FE":0.5808,"Google Pixel 9 Pro XL":0.6056,"Google Pixel 8":0.5851,"Google Pixel 8 Pro":0.5847,"Google Pixel 7":0.5902,"Google Pixel 6":0.5762,"iPhone 12 / 12 Pro":0.607,"iPhone X / XS":0.6245,"iPhone 6 / 7 / 8 / SE":0.6217,"Google Pixel 9 / 9 Pro":0.6251},"magtough":{"iPhone 18 Pro":0.5988,"iPhone 18 Pro Max":0.5886,"iPhone 17":0.5971,"iPhone 17 Air":0.5942,"iPhone 17 Pro":0.5988,"iPhone 17 Pro Max":0.5886,"iPhone 16":0.5976,"iPhone 16 Plus":0.6053,"iPhone 16 Pro":0.5976,"iPhone 16 Pro Max":0.6053,"iPhone 15":0.5976,"iPhone 15 Plus":0.6053,"iPhone 15 Pro":0.5976,"iPhone 15 Pro Max":0.6053,"iPhone 14":0.5976,"iPhone 14 Plus":0.6052,"iPhone 14 Pro":0.5976,"iPhone 14 Pro Max":0.6052,"iPhone 13":0.607,"iPhone 13 Pro":0.607,"iPhone 13 Pro Max":0.5959}};
  function dyoCaseKey() { return /magsafe/i.test(selectedCaseType()) ? 'magtough' : 'tough'; }
  function dyoAspect() { return (DYO_ASPECTS[dyoCaseKey()] || {})[CFG.model] || 0.6; }
  // The currently selected Case Type value on the PDP (pdp-ct tiles or a plain option group).
  function selectedCaseType() {
    var el = document.querySelector('[data-pdp-ct] input:checked');
    if (!el) {
      var groups = [].slice.call(document.querySelectorAll('[data-pdp-options] .pdp-option'));
      for (var i = 0; i < groups.length; i++) {
        var lbl = groups[i].querySelector('.pdp-option__label');
        if (lbl && /case type/i.test(lbl.textContent)) { el = groups[i].querySelector('input:checked'); break; }
      }
    }
    return el ? (el.value || '').trim() : '';
  }
  // Garment colour behind an apparel plate, matched to the collection-card swatches so the
  // editor and the grid agree. Apparel only — other flat products (backpack, lunchbox) keep the
  // pale plate, which marks a printable region rather than standing in for the product itself.
  var GARMENT_HEX = { white: '#ffffff', grey: '#a6a6a6', black: '#161616', sand: '#d8c8a8', pink: '#f2c4d3', blue: '#b4d0e6' };
  // The value currently selected in a plain PDP option group, found by its label.
  function selectedOption(re) {
    var groups = [].slice.call(document.querySelectorAll('[data-pdp-options] .pdp-option'));
    for (var i = 0; i < groups.length; i++) {
      var lbl = groups[i].querySelector('.pdp-option__label');
      if (lbl && re.test(lbl.textContent)) {
        var el = groups[i].querySelector('input:checked');
        return el ? (el.value || '').trim() : '';
      }
    }
    return '';
  }
  function garmentColour() {
    if (!/t-shirt|hoodie|sweatshirt|crop top/i.test(CFG.productType || '')) return null;
    return GARMENT_HEX[selectedOption(/colour/i).toLowerCase()] || null;
  }
  // Outsourced case types (Printify/WOYC) — no in-house live composite exists for them.
  function isOutsourcedCase() { return /^(tough|snap|magsafe tough)$/i.test(selectedCaseType()); }
  // DYO / Custom Photo apparel on Printify (blueprint 6 / provider 99). The hub derives the
  // Printify variant from colour + size on every request, so both are read fresh at save time —
  // one product serves a whole colourway, and the size must never come from whichever request
  // happened to create it.
  var TEE_COLOUR_CODE = { white: 'WHT', grey: 'GRY', black: 'BLK', sand: 'SND', pink: 'LPK', blue: 'LBU' };
  // Size vocabulary is per product type and must match the Shopify option values EXACTLY — the
  // hub maps these codes to Printify variants, so a cosmetic difference breaks routing silently.
  // Adults are bp6 (S-2XL); kids are bp157, a different blueprint with its own print-area aspect.
  var TEE_SIZE_CODE = {
    'T-Shirt': { 'small': 'S', 'medium': 'M', 'large': 'L', 'extra large': 'XL', 'double extra large': '2XL' },
    'Kids T-Shirt': { 'xs (3-4)': 'XS', 's (5-6)': 'S', 'm (7-8)': 'M', 'l (9-11)': 'L', 'xl (12-13)': 'XL' },
    // Hoodie is bp77 (Gildan 18500), adult S-2XL like the tee. Its PRINT AREAS differ sharply
    // though — a landscape band on the front — which the flat mask already handles.
    'Hoodie': { 'small': 'S', 'medium': 'M', 'large': 'L', 'extra large': 'XL', 'double extra large': '2XL' },
  };
  function teeSpec() {
    var type = (CFG.productType || '').trim();
    var sizes = TEE_SIZE_CODE[type];
    if (!sizes) return null;                       // not apparel we can route
    var colour = TEE_COLOUR_CODE[selectedOption(/colour/i).toLowerCase()];
    var size = sizes[selectedOption(/size/i).toLowerCase()];
    if (!colour || !size) return null;
    return { productType: type, colour: colour, size: size,
      position: /back/i.test(selectedOption(/print position/i)) ? 'back' : 'front' };
  }
  // Printify returns EVERY camera for the blueprint — 37 on a Gildan 5000, including size
  // charts, collar and sleeve closeups, and cameras pointed away from the print. Taking the
  // first URL showed a BACK print on the FRONT camera: a blank shirt. Curate, and lead with the
  // side the design is actually on. Roles verified against a real back-print product: 'person-N'
  // is a front view, 'person-N-back' a rear one, and 'duo' shows both models so it serves either.
  // Camera names are per BLUEPRINT, not shared: adults (bp6) use bare 'person-N' for front views
  // and 'person-N-back' for rear, plus 'duo'. Kids (bp157) use an explicit '-front' suffix, add a
  // 'person-2-context' shot and have no 'duo' at all — so matching adult names against a kids
  // product would drop every person shot. Roles were checked by eye against a real front-print
  // product of each blueprint; Printify's own `position` field is not reliable (on bp157 it files
  // person-2-front as "other" and person-2-context as "front").
  var TEE_CAMERAS = {
    'T-Shirt': {
      front: ['front', 'front-2', 'person-1', 'person-2', 'person-5', 'person-6', 'duo', 'hanging-1', 'folded'],
      back: ['back', 'back-2', 'person-5-back', 'person-6-back', 'person-7-back', 'person-8-back', 'duo'],
    },
    'Kids T-Shirt': {
      front: ['front', 'front-2', 'person-1-front', 'person-2-front', 'person-2-context'],
      back: ['back', 'back-2', 'person-1-back', 'person-2-back'],
    },
    // bp77 mixes both conventions: bare 'person-N' for front views AND an explicit
    // 'person-6-front'. Roles measured by printing a magenta block on the front only and scanning
    // all 18 mockups for it — front-collar-closeup and the sleeve cameras show the print but crop
    // it badly, so they are left out; size-chart never shows it.
    'Hoodie': {
      front: ['front', 'front-2', 'person-1', 'person-2', 'person-3', 'person-4', 'person-6-front', 'lifestyle', 'folded'],
      back: ['back', 'back-2', 'person-4-back', 'person-6-back'],
    },
  };
  function orderTeeMockups(urls, type, position) {
    var set = TEE_CAMERAS[type];
    if (!set) return urls;                  // unknown blueprint → leave the hub's order alone
    var by = {};
    urls.forEach(function (u) {
      var m = /[?&]camera_label=([^&]+)/.exec(u);
      if (m) by[decodeURIComponent(m[1])] = u;
    });
    var picked = (set[position] || set.front).map(function (l) { return by[l]; }).filter(Boolean);
    return picked.length ? picked : urls;
  }
  // Falls back to false when the options can't be read, so an unexpected PDP degrades to the
  // normal save (design still attached, team reviews it) rather than an unroutable Printify line.
  function skuIsOutsourced() {
    // The selected variant, read from the same element the PDP uses for add-to-cart, so this can
    // never disagree with what is actually being bought.
    var el = document.querySelector('[data-pdp-variant-id]');
    var map = CFG.outsourcedVariants;
    if (!el || !map) return false;
    return !!map[String(el.value)];
  }
  // ADDITIVE on purpose: `CFG.isCustom ||` keeps every product that works today on exactly its
  // current path, and the new branch only opens for a variant whose SKU is already outsourced.
  // Verified before shipping: all 5 personalisable apparel products carrying outsourced SKUs are
  // Design-Your-Own / Custom-Photo, so they already pass via isCustom and this changes nothing for
  // them. It exists for the personalised-barbie-* garments, which are customer-designed (the buyer
  // types a name) but match neither handle.
  function isOutsourcedApparel() { return !!((CFG.isCustom || skuIsOutsourced()) && teeSpec()); }
  function resolveEntry() {
    // Spreadsheet-driven placed/flat entries win — even on phone-type products like the wallet
    // case (which has a model option but is really a flat overlay, not a live phone composite).
    var entry = resolveMockupEntry();
    if (entry && (entry.mode === 'placed' || entry.mode === 'flat')) return entry;
    var live = liveEntry(); if (live) return live;
    // Custom / Design-Your-Own on an outsourced case type (Tough / MagSafe Tough): a flat blank
    // artboard sized to the case's REAL per-model print-area aspect, so the design maps 1:1 onto
    // the Printify case (no crop/margin). Never the baked Standard mockup (that showed the wrong case).
    if (CFG.isCustom && isOutsourcedCase()) return { mode: 'flat', ratio: dyoAspect() };
    return entry;
  }
  // Apply the resolved entry: set mode/print, size the board (print mode follows the garment aspect),
  // place the image as an OVERLAY (transparent window on top) or BACKGROUND (garment behind).
  function applyEntry() {
    if (!fcanvas) return;
    VIEWCROP = null; CASE_HARD = null; fcanvas.clipPath = null;
    // A product-type flat mask (Backpack, Lunchbox, …) wins over every mockup pipeline:
    // the customer designs on the real print area, so nothing is scaled or repositioned
    // between the editor and the print file.
    var flatMk = flatMaskForSelection();
    if (flatMk && flatMk.mask) { applyMaskEntry(flatMk, { flat: true }); return; }
    // A wallet with a FLIP plate designs on the real print area, which beats the placed mockup
    // for the same reason a snap case's GoBear plate does: nothing is scaled or guessed between
    // the editor and the print file. No FLIP mask for this model falls through unchanged.
    if (isWallet()) {
      var flipPlate = maskEntryForSelection();
      if (flipPlate) { applyMaskEntry(flipPlate); return; }
    }
    var entry = resolveEntry();
    // Spreadsheet-driven modes take priority (so the wallet case uses 'placed', not the phone pipeline).
    if (entry && entry.mode === 'flat') { applyFlatEntry(entry); return; }
    if (entry && entry.mode === 'placed') { applyPlacedEntry(entry); return; }
    // Phones use the server-side (Cloudinary) pipeline: design backdrop + case overlay.
    // A GoBear plate for the CURRENT model + material beats the Cloudinary mockup: the customer
    // designs on the real printable shape, so nothing is scaled or guessed between the editor and
    // the print file. Design-backed cases keep their artwork — it loads as a locked base layer on
    // the plate (see applyMaskEntry) and the customer adds to it. No plate for this combination
    // (uncovered model, Bumper, Tough…) falls through to the mockup exactly as before.
    if (CFG.isPhone) {
      var plateForPhone = maskEntryForSelection() || (CFG.template ? templatePlateFallback() : null);
      if (plateForPhone) { applyMaskEntry(plateForPhone); return; }
    }
    if (CFG.isPhone && CFG.baseDesignRaw) { applyPhoneEntry(); return; }
    // DYO / Custom-Photo, in-house case type (Standard / Standard MagSafe): no base design, so frame it
    // cleanly here. (Outsourced Tough / MagSafe Tough are already handled above via the flat artboard.)
    if (CFG.isCustom && CFG.isPhone) { applyCustomPhoneEntry(); return; }
    PIPE = 'placed';   // generic overlay products finish through finishPlaced
    loading(true);   // keep the spinner up until the mockup is actually on the board
    if (!entry || !entry.url) { MODE = 'overlay'; PRINT = null; fcanvas.setOverlayImage(null, function () {}); fcanvas.setBackgroundImage(null, function () {}); drawGuides(); fcanvas.requestRenderAll(); loading(false); return; }
    MODE = entry.mode; PRINT = entry.print; FRAMEFIT = entry.frameFit || 0;
    fabric.Image.fromURL(entry.url, function (img) {
      if (!img) { drawGuides(); loading(false); return; }
      AH = Math.round(AW / (img.width / img.height));   // artboard follows the mockup for BOTH modes
      img.set({ selectable: false, evented: false }); img.scaleToWidth(AW);
      var after = function () { drawGuides(); loadBaseDesign(); fitBoard(); fcanvas.requestRenderAll(); loading(false); };
      if (MODE === 'print') {
        fcanvas.setOverlayImage(null, function () {});
        fcanvas.setBackgroundImage(img, after);
      } else {
        fcanvas.setBackgroundImage(null, function () {});
        fcanvas.setOverlayImage(img, after);
      }
    }, { crossOrigin: 'anonymous' });
  }
  // FIX (test): fl_no_overflow on the placed-mode layer stops an oversized mockup layer (e.g.
  // backpack-front at 2048px vs the 1700px recipe frame) expanding the canvas — the expansion made
  // the configured print fractions wrong and baked white padding into every backpack print file.
  // 'placed' mode: the base design is pre-placed by Cloudinary using the spreadsheet recipe
  // (mockup at opacity 0 sets the frame → design at the exact size/position). Loaded as a locked
  // base object filling the board, with the real mockup overlaid on top. PRINT = the design's area.
  function applyPlacedEntry(entry) {
    loading(true);
    PIPE = 'placed';
    MODE = 'overlay'; PRINT = entry.print || null; FRAMEFIT = 0; VIEWCROP = null;
    var CL = 'https://res.cloudinary.com/' + CFG.cloudName + '/';
    var fx = entry.layerFx ? ',' + entry.layerFx : '';
    var raw = CFG.baseDesignRaw;
    // Mockup in the SAME frame as the placed design (design made invisible with o_0), so any
    // layer offset stays aligned; fall back to the raw mockup for blank (custom) products.
    var mockupUrl = (raw && entry.baseTransform)
      ? CL + 'image/fetch/' + entry.baseTransform + '/o_0/l_' + entry.mockupLayer + fx + ',fl_no_overflow,fl_layer_apply/f_png/' + raw
      : CL + 'image/upload/f_png/' + entry.mockupLayer;
    fabric.Image.fromURL(mockupUrl, function (mimg) {
      if (mimg && mimg.width) { AH = Math.round(AW / (mimg.width / mimg.height)); mimg.set({ selectable: false, evented: false }); mimg.scaleToWidth(AW); }
      else { AH = AW; }
      fcanvas.setBackgroundImage(null, function () {});
      fcanvas.setOverlayImage(mimg && mimg.width ? mimg : null, function () {
        var finishPlaced = function () {
          drawGuides();
          fcanvas.getObjects().filter(function (o) { return o._pzGuide; }).forEach(function (g) { fcanvas.sendToBack(g); });
          fitBoard(); fcanvas.requestRenderAll(); loading(false); snapshot();
        };
        if (CFG.baseDesignRaw && entry.baseTransform) {
          var placedUrl = CL + 'image/fetch/' + entry.baseTransform + '/l_' + entry.mockupLayer + fx + ',o_0,fl_no_overflow,fl_layer_apply/f_png/' + raw;
          fabric.Image.fromURL(placedUrl, function (dimg) {
            if (dimg && dimg.width) {
              var sc = AW / dimg.width;   // the placed design IS the full frame — fill the board 1:1
              dimg.set({ left: 0, top: 0, originX: 'left', originY: 'top', scaleX: sc, scaleY: sc, selectable: false, evented: false });
              dimg._pzBase = true; baseLoaded = true;
              fcanvas.add(dimg); fcanvas.sendToBack(dimg);
            }
            finishPlaced();
          }, { crossOrigin: 'anonymous' });
        } else { baseLoaded = true; finishPlaced(); }
      });
    }, { crossOrigin: 'anonymous' });
  }
  // 'flat' mode (clothing/drinkware): a plain artboard at the product ratio. The base design is
  // contained (fit, never stretched); the customer designs on the flat artwork. No mockup — the
  // garment/drinkware preview is composited by Cloudinary on Done.
  var flatEntry = null;
  function applyFlatEntry(entry) {
    loading(true);
    PIPE = 'flat';
    MODE = 'flat'; PRINT = [0, 0, 1, 1]; FRAMEFIT = 0; VIEWCROP = null; flatEntry = entry;
    AH = Math.round(AW / (entry.ratio || 0.7071));
    fcanvas.setOverlayImage(null, function () {});
    fcanvas.setBackgroundImage(null, function () {});
    var done = function () { drawGuides(); fitBoard(); fcanvas.requestRenderAll(); loading(false); snapshot(); };
    if (CFG.baseDesign) {
      fabric.Image.fromURL(CFG.baseDesign, function (dimg) {
        if (dimg && dimg.width) {
          var scale = Math.min(AW / dimg.width, AH / dimg.height);   // contain — fit whole, centred
          dimg.set({ left: AW / 2, top: AH / 2, originX: 'center', originY: 'center', scaleX: scale, scaleY: scale, selectable: false, evented: false });
          dimg._pzBase = true; baseLoaded = true;
          fcanvas.add(dimg); fcanvas.sendToBack(dimg);
        }
        done();
      }, { crossOrigin: 'anonymous' });
    } else { baseLoaded = true; done(); }
  }
  // Capture the whole flat artboard (base design + additions) transparent, at print resolution.
  function captureArtboard() {
    fcanvas.discardActiveObject();
    var bc = fcanvas.backgroundColor;
    fcanvas.backgroundColor = '';
    fcanvas.getObjects().forEach(function (o) { if (o._pzGuide) o.visible = false; });
    var z = fcanvas.getZoom();
    var data = fcanvas.toDataURL({ format: 'png', multiplier: (CFG.exportWidth || 2500) / (AW * z) });
    fcanvas.backgroundColor = bc;
    fcanvas.getObjects().forEach(function (o) { if (o._pzGuide) o.visible = true; });
    fcanvas.requestRenderAll();
    return dataURLtoBlob(data);
  }

  /* ---------- phone pipeline (Cloudinary-composited) ---------- */
  var CASE_LID = null, DESIGN_ASPECT = 0.5, DESIGN_NATIVE_W = 2000, VIEWCROP = null, CASE_HARD = null;
  // Margin in CSS px reserved around the board inside the canvas element. fitBoard used to size the
  // element to exactly the board, so an object overhanging it had its resize/rotate handles drawn
  // outside the element and therefore invisible and un-grabbable. That is now the normal case: a
  // cover-fitted photo whose aspect differs from the print area always overhangs on one axis, and
  // on a phone the mask IS the board so there is nowhere else for the handles to go.
  // Everything that reads canvas coordinates must add the viewport offset — see exportArt.
  var BOARD_PAD = 26;
  // The e_trim (tight) case URL + its layer id for the current selection.
  function phoneCase() {
    var entry = resolveEntry();
    if (!entry || !entry.url) return null;
    var lid = entry.url.split('/').pop();
    if (!lid) return null;
    return { lid: lid, url: 'https://res.cloudinary.com/dpuznvkgc/image/upload/e_trim/f_png/' + lid };
  }
  // Editor: DESIGN as the backdrop (fills the design-frame board) + the CASE framed to the same
  // 1000² frame the composite uses, placed ON TOP as an overlay. The case's opaque bezel + border
  // therefore COVER anything the customer places outside the printable window (the clipping they
  // expect), while the transparent window shows the design + their additions. Positioning matches
  // the real product composite because both use the identical frame math.
  function applyPhoneEntry() {
    loading(true);
    PIPE = 'phone';
    MODE = 'overlay';
    var pc = phoneCase();
    CASE_LID = pc ? pc.lid : null;
    fabric.Image.fromURL(CFG.baseDesign, function (dimg) {
      if (dimg && dimg.width) { DESIGN_ASPECT = dimg.width / dimg.height; DESIGN_NATIVE_W = dimg.width; }
      else { DESIGN_ASPECT = 0.5; DESIGN_NATIVE_W = 2000; }
      AH = Math.round(AW / DESIGN_ASPECT);
      if (dimg && dimg.width) { dimg.set({ selectable: false, evented: false }); dimg.scaleToWidth(AW); }
      var withCase = function (caseAspect) {
        // Match the SAVED image exactly: the design fills the board, additions live on it (the
        // print), and the case overlay is rendered with the SAME Cloudinary recipe as the composite
        // (design hidden with o_0, case layer applied) — so what the customer designs === what saves.
        // The composite frame is square; the design fills its height, so we show an AH×AH window
        // centred on the design and scale the case so its transparent print window lands on the design.
        PRINT = [0, 0, 1, 1];
        VIEWCROP = { left: (AW - AH) / 2, top: 0, width: AH, height: AH };
        var raw = CFG.baseDesignRaw;
        var render = function () { drawGuides(); fitBoard(); fcanvas.requestRenderAll(); loading(false); };
        fcanvas.setBackgroundImage(dimg && dimg.width ? dimg : null, function () {
          if (!CASE_LID || !raw) { fcanvas.setOverlayImage(null, render); return; }
          var ovUrl = 'https://res.cloudinary.com/' + CFG.cloudName + '/image/fetch/w_1000,h_1000,c_pad,g_center/o_0/c_scale,h_940/l_' + CASE_LID + ',fl_layer_apply/f_png/' + raw;
          fabric.Image.fromURL(ovUrl, function (oc) {
            if (!oc || !oc.width) { fcanvas.setOverlayImage(null, render); return; }
            var sc = AH / oc.height;   // composite frame (940) → design height (AH); case centres on the design
            oc.set({ selectable: false, evented: false, originX: 'center', originY: 'center', scaleX: sc, scaleY: sc, left: AW / 2, top: AH / 2 });
            fcanvas.setOverlayImage(oc, render);
          }, { crossOrigin: 'anonymous' });
        });
      };
      if (pc) fabric.Image.fromURL(pc.url, function (ci) { withCase(ci && ci.width ? ci.width / ci.height : null); }, { crossOrigin: 'anonymous' });
      else withCase(null);
    }, { crossOrigin: 'anonymous' });
  }
  // ── FLAT-PLATE (mask-driven) pipeline ─────────────────────────────────────────
  // Authored geometry from shop metafield custom.personalise_masks (GoBear plates /
  // manual masks): CFG.caseMasks = { M2|M3|M5: { mask, frame:[w,h], bbox:[x,y,w,h] } }
  // for the CURRENT model. The mask image (black shape = printable) is the design
  // surface: canvas-level clip + a case-tinted backdrop. Print = rect crop at bbox,
  // full bleed — the mask itself is never rasterised into the print file.
  // A folio wallet, not a snap case. Its only option is "Phone Model", so it has no Case Type
  // to select and must be identified by product type.
  function isWallet() { return /wallet/i.test(CFG.productType || ''); }
  function maskEntryForSelection() {
    var mm = CFG.caseMasks; if (!mm) return null;
    // The wallet's plate is the supplier-authored FLIP entry. Without this it would fall through
    // to the 'Standard' branch below and be given snap-case geometry. A model with no FLIP mask
    // yet returns null and falls back to the mockup pipeline.
    if (isWallet()) {
      return (mm.FLIP && mm.FLIP.mask && mm.FLIP.frame && mm.FLIP.bbox)
        ? Object.assign({ material: 'FLIP' }, mm.FLIP) : null;
    }
    var ct = selectedCaseType() || 'Standard';
    var side = currentSide();
    var mat = null;
    // Outsourced (Printify/WOYC) case types. The plate is Printify's own print rectangle for this
    // model — a plain rect, no silhouette and no camera cutout, because that is all the API
    // exposes. Michael accepted the cutout being ignored: the Printify mockup shows the real
    // result afterwards, and the customer can reopen the editor to move anything awkward.
    if (/^tough$/i.test(ct)) mat = 'TOUGH';
    else if (/^magsafe tough$/i.test(ct)) mat = 'MAGTOUGH';
    // Bumper has supplier-authored plates of its own now (BUMPER in custom.personalise_masks),
    // so it designs on the real print area like every other case type. A model with no BUMPER
    // plate still returns null below and falls through exactly as before.
    else if (/^bumper$/i.test(ct)) mat = 'BUMPER';
    else if (/^standard magsafe$/i.test(ct)) mat = 'M2';
    else if (/^standard$/i.test(ct)) {
      // White sides use the Clear plate geometry (same shape) — every colour is flat-plate now.
      if (/clear/i.test(side)) mat = 'M3';
      else if (/black/i.test(side)) mat = 'M5';
      else if (/white/i.test(side)) mat = mm.M3 ? 'M3' : mm.M5 ? 'M5' : null;
    }
    if (!mat || !mm[mat] || !mm[mat].mask || !mm[mat].frame || !mm[mat].bbox) return null;
    return Object.assign({ material: mat }, mm[mat]);
  }
  // A template REPLACES the stock artwork, so it must never fall through to the base-design
  // pipeline — that paints the original JPEG behind the canvas and composites the customer's
  // layers back onto it, printing the design twice (FC366800, a polaroid on Bumper). Bumper
  // has its own BUMPER plates now, but not for every model, so this remains the fallback when
  // one is missing: borrow the Standard plate — same case body, same print area, and it gives
  // the template a real print rectangle to sit on. Geometry only.
  function templatePlateFallback() {
    var mm = CFG.caseMasks; if (!mm) return null;
    // A folio must never borrow a snap-case plate: different shape, different print area.
    if (isWallet()) return null;
    var side = currentSide();
    var pick = (/black/i.test(side) && mm.M5) ? 'M5' : (mm.M3 ? 'M3' : (mm.M5 ? 'M5' : (mm.M2 ? 'M2' : null)));
    if (!pick || !mm[pick] || !mm[pick].mask || !mm[pick].frame || !mm[pick].bbox) return null;
    return Object.assign({ material: pick }, mm[pick]);
  }
  // A flat type whose print area changes with a variant option (Laptop Sleeve: Small 239x333,
  // Large 267x385) ships one mask per option VALUE in CFG.flatMasks, keyed by variant title.
  // Liquid already resolved the selected one into CFG.flatMask, but the shopper can change size
  // without a reload, so resolve again from the live selection every time the editor opens.
  // Size is a variant option, so product.js's unsaved-design guard covers the mid-design case.
  function flatMaskForSelection() {
    var byOpt = CFG.flatMasks;
    if (!byOpt) return CFG.flatMask;
    var sel = currentSelections();               // every checked option value, lowercased
    for (var k in byOpt) {
      if (!byOpt.hasOwnProperty(k)) continue;
      if (sel.indexOf(String(k).toLowerCase().trim()) > -1) return byOpt[k];
    }
    return CFG.flatMask;                         // unmatched -> the server's choice, never a guess
  }
  // Trace a mask's silhouette from the loaded image, as fractions of its own box. Used by the
  // print guide when a mask carries no authored outline: a fixed-radius rounded rect cut across
  // every real corner. Row-scan for the leftmost/rightmost opaque pixel, then walk down the left
  // edge and back up the right — the same construction the ingest tracer uses, so an authored and
  // a runtime outline describe the same shape. Interior holes (a camera cutout) are ignored on
  // purpose: the guide marks the outer printable boundary, not every island inside it.
  function traceMaskOutline(imgEl, rows) {
    try {
      var iw = imgEl && (imgEl.naturalWidth || imgEl.width), ih = imgEl && (imgEl.naturalHeight || imgEl.height);
      if (!iw || !ih) return null;
      var S = 220;
      var c = document.createElement('canvas');
      c.width = S; c.height = Math.max(2, Math.round(ih * S / iw));
      var ctx = c.getContext('2d');
      ctx.drawImage(imgEl, 0, 0, c.width, c.height);
      var d = ctx.getImageData(0, 0, c.width, c.height).data;   // throws if the image is tainted
      var L = [], R = [], ys = [], step = Math.max(1, Math.floor(c.height / (rows || 60)));
      for (var y = 0; y < c.height; y += step) ys.push(y);
      if (ys[ys.length - 1] !== c.height - 1) ys.push(c.height - 1);   // never clip the bottom edge
      for (var i = 0; i < ys.length; i++) {
        var yy = ys[i], lx = -1, rx = -1;
        for (var x = 0; x < c.width; x++) if (d[(yy * c.width + x) * 4 + 3] > 127) { if (lx < 0) lx = x; rx = x; }
        if (lx < 0) continue;
        L.push({ x: lx / c.width, y: yy / c.height });
        R.push({ x: (rx + 1) / c.width, y: yy / c.height });
      }
      if (L.length < 4) return null;
      return L.concat(R.reverse());
    } catch (e) { return null; }
  }
  /* ── Editable design templates ────────────────────────────────────────────────
     A template is a locked layout plus a whitelist of slots. Anything not named in `slots` is
     furniture the customer cannot touch. Geometry is resolved against the FRAME box (itself a
     fraction of the print area), so one template lands correctly on any plate. */
  var tplLoaded = false, tplFontsReady = false, tplFontsWatched = false, tplPhotoSrc = null, tplCaption = null;
  // Where the customer dragged/scaled the text, if they did. Null means "use the design's default".
  var tplTextXform = null;
  // Customer-chosen values. A polaroid has none of these and stays on the slot's fixed font/fill;
  // a monogram makes all three the customer's decision. Null everywhere means "the design decides".
  var tplChoice = {};          // choice-slot id -> option id  (e.g. background: 'STR-004')
  var tplFont = null;          // chosen font family
  var tplFill = null;          // chosen fill hex
  // Chosen OUTLINE, held as an option id rather than a colour. A colour cannot express the two
  // states that are not colours — 'auto' (derive from the fill) and 'none' (no outline at all) —
  // and an empty string would be ambiguous with "not yet chosen".
  var tplStrokeId = null;
  // Chosen block shadow — the hard offset duplicate behind the letter, fabric.Shadow with zero
  // blur. Held as an option id for the same reason the stroke is: 'auto' and 'none' are not
  // colours. 'auto' derives from the fill's luminance (dark shadow under a light letter).
  var tplShadowId = null;
  // Resolve an outline option to an actual stroke colour, or null for none.
  // Customer-set gradient stops. Distinct from a choice slot: a gradient is DRAWN, not fetched, so
  // there is no image to pick and the customer can land on any colour rather than a preset.
  var tplGradFrom = null, tplGradTo = null;

  // The finish button says what it will actually do. On an outsourced case it does NOT add to bag —
  // it builds a Printify mockup and reveals the gallery, and that reveal is the point of the wait,
  // so promising "add to bag" there would be a lie and would bury the thing the customer waited for.
  function syncDoneLabel() {
    var el = modal && modal.querySelector('[data-pz-done-label]');
    if (!el) return;
    var outsourced = selectedCaseTypeOutsourced() || isOutsourcedApparel();
    el.textContent = outsourced ? 'Create my preview' : 'Save and add to bag';
  }

  // Click the PDP's own Add to bag rather than posting the form here: the theme owns cart
  // behaviour (drawer, validation, sold-out state) and duplicating it would drift.
  function pzAddToBag() {
    var b = document.querySelector('[data-pdp-submit]');
    if (!b || b.disabled) return false;
    b.click();
    return true;
  }

  /* ── floating add-to-bag bar ───────────────────────────────────────────────────────
     Appears only once a design is SAVED, and only while the real Add to bag is off screen.
     Both conditions matter: on page load there is nothing to add, and duplicating a button that
     is already visible is just clutter. */
  var pzBar = null, pzBarObs = null, pzAtcVisible = true;
  function pzBarSync() {
    if (!pzBar) return;
    pzBar.classList.toggle('is-on', designAttached && !pzAtcVisible);
  }
  function pzEnsureBar(thumbSrc) {
    if (!pzBar) {
      pzBar = document.createElement('div');
      pzBar.className = 'pz-bar';
      pzBar.setAttribute('role', 'region');
      pzBar.setAttribute('aria-label', 'Add your design to bag');
      pzBar.innerHTML =
        '<img class="pz-bar__thumb" alt="" data-pz-bar-thumb>' +
        '<span class="pz-bar__txt"><b>Your design is saved</b><i data-pz-bar-sub></i></span>' +
        '<button type="button" class="pz-bar__btn" data-pz-bar-add>Add to bag</button>';
      document.body.appendChild(pzBar);
      pzBar.addEventListener('click', function (e) {
        if (e.target.closest('[data-pz-bar-add]')) { e.preventDefault(); pzAddToBag(); }
      });
      var atc = document.querySelector('[data-pdp-submit]');
      if (atc && window.IntersectionObserver) {
        pzBarObs = new IntersectionObserver(function (en) {
          pzAtcVisible = en[0].isIntersecting; pzBarSync();
        // Expand the bottom of the observed area, do not shrink it. A NEGATIVE bottom margin
        // meant the real Add to bag counted as "not visible" while it sat in the bottom 40px —
        // precisely the strip this bar covers — so both were on screen at once. Expanding by
        // more than the bar's height hides the bar just BEFORE the real button scrolls in.
        }, { rootMargin: '0px 0px 120px 0px' });
        pzBarObs.observe(atc);
      } else {
        pzAtcVisible = false;      // no observer: better to show it than to hide it forever
      }
    }
    var t = pzBar.querySelector('[data-pz-bar-thumb]');
    if (t && thumbSrc) t.src = thumbSrc;
    var sub = pzBar.querySelector('[data-pz-bar-sub]');
    if (sub) {
      var price = document.querySelector('[data-pdp-price]');
      sub.textContent = price ? price.textContent.trim() : '';
    }
    pzBarSync();
  }

  function tplStrokeOf(opt, fill) {
    if (!opt) return null;
    if (opt.auto) return tplAutoStroke(fill);
    return opt.hex || null;
  }
  function tplChoiceSlots() {
    return (CFG.template.slots || []).filter(function (s) { return s.kind === 'choice'; });
  }
  function tplOption(slot, id) {
    var o = (slot.options || []).filter(function (x) { return x.id === id; })[0];
    return o || (slot.options || [])[0];
  }
  // Relative luminance, so an outline can be picked that actually separates the letter from the
  // stripes underneath. A monogram sits on artwork we do not control — a white letter on the cream
  // ground of STR-011 would otherwise vanish — so every colour gets a contrasting outline rather
  // than only the pale ones.
  function tplLum(hex) {
    var h = String(hex || '').replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16);
    if (isNaN(n)) return 1;
    var f = function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
    return 0.2126 * f((n >> 16) & 255) + 0.7152 * f((n >> 8) & 255) + 0.0722 * f(n & 255);
  }
  function tplAutoStroke(fill) { return tplLum(fill) > 0.45 ? '#161616' : '#FFFFFF'; }

  // How much of the em box a glyph's INK actually occupies, for this family and this character.
  //
  // Needed because fabric sizes text by the LINE BOX, and the line box is mostly empty space on a
  // script face — Allura reserves room for tall ascenders and deep descenders that a capital M
  // never uses. Sizing six different faces to the same line-box height therefore renders Playfair
  // large and Allura small, at the same nominal fontSize. Measuring the ink is font-agnostic: it is
  // correct for all six and for any face added later, with no per-font constants to maintain.
  //
  // Cached per family+char — constant for a given pair, and this runs on every keystroke.
  var tplInkCache = {};
  function tplInkRatio(family, ch) {
    var key = family + ' ' + ch;
    if (tplInkCache[key] != null) return tplInkCache[key];
    try {
      var S = 100, pad = 80;
      var c = document.createElement('canvas');
      c.width = S * 3 + pad * 2; c.height = S * 3 + pad * 2;
      var x = c.getContext('2d');
      x.font = S + 'px "' + family + '"';
      x.textBaseline = 'alphabetic'; x.fillStyle = '#000';
      x.fillText(ch, pad, c.height / 2);
      var d = x.getImageData(0, 0, c.width, c.height).data;
      var top = -1, bot = -1;
      for (var y = 0; y < c.height; y++) {
        for (var xx = 0; xx < c.width; xx++) {
          if (d[(y * c.width + xx) * 4 + 3] > 10) { if (top < 0) top = y; bot = y; break; }
        }
      }
      if (top < 0) return null;                       // nothing drawn — do not cache a bad reading
      var r = (bot - top + 1) / S;
      tplInkCache[key] = r;
      return r;
    } catch (e) { return null; }
  }

  // Load the template's faces and WAIT. Text rendered before its font is ready bakes the fallback
  // into the print file, and it looks correct on screen because the real face lands moments later.
  function tplFontFamilies() {
    return ((CFG.template && CFG.template.fonts) || []).map(function (f) { return f.family; });
  }
  // Families the FontFace API has confirmed. An explicit entry here beats any measurement.
  var tplFaceReady = {}, tplProbeCtx = null;
  // Measure, do not ask. document.fonts.check() returns TRUE for a family with no @font-face rule,
  // because an unknown family resolves to a system fallback and would therefore "render" — which is
  // indistinguishable from success at exactly the moment we need to tell them apart. Rendering the
  // probe in '"<family>", monospace' and comparing against plain monospace does tell them apart: a
  // face that has not arrived falls through to monospace and the widths match to the pixel.
  function tplProbeFamily(fam) {
    try {
      if (!tplProbeCtx) tplProbeCtx = document.createElement('canvas').getContext('2d');
      var s = 'MWmwil@#08Retro Dolly';
      tplProbeCtx.font = '72px monospace';
      var base = tplProbeCtx.measureText(s).width;
      tplProbeCtx.font = '72px "' + fam + '", monospace';
      return Math.abs(tplProbeCtx.measureText(s).width - base) > 0.5;
    } catch (e) { return true; }   // cannot measure: do not hold the editor hostage
  }
  // Every family the template asks for is genuinely rasterisable right now.
  function tplFontsAvailable() {
    try {
      // Only the face actually being drawn has to be ready. A template offering the customer six
      // fonts declares all six, and requiring the whole set would mean one slow or dead CDN entry
      // held the text in a fallback for every customer — including those who never pick that font.
      var active = tplFont || (tplTextSlot() || {}).font;
      var f = active ? [active] : tplFontFamilies();
      if (!f.length) return true;
      return f.every(function (fam) {
        if (tplFaceReady[fam]) return true;
        return tplProbeFamily(fam);
      });
    } catch (e) { return true; }
  }
  // Fabric measures a Text object ONCE, at construction. A face that lands afterwards is never
  // picked up — not by a re-render, not by setting fontFamily again — so the only reliable fix is
  // to DESTROY AND REBUILD the object. Cheap, and it is the difference between the customer's
  // words being printed in Allura or in Times.
  function tplRefreshText() {
    if (!tplLoaded) return;
    // tplCaption can still be null when the font settles: applyTemplateLayers arms the watcher
    // before it assigns the default, and document.fonts.ready resolves on a microtask — sooner
    // than the image callback that does the assigning. Bailing here is what left the PRE-LOADED
    // name in the fallback face while a re-typed one came out correct.
    var slot = tplTextSlot();
    var text = tplCaption !== null ? tplCaption : ((slot && slot.default) || '');
    if (!text) return;
    tplSetCaption(text);
  }
  // Watch until the faces really are available, then rebuild once. Covers the slow-CDN case the
  // timeout below deliberately does not block on.
  function tplWatchFonts() {
    if (tplFontsWatched) return;
    tplFontsWatched = true;
    var settle = function () { if (tplFontsAvailable()) tplRefreshText(); };
    try { document.fonts.ready.then(settle).catch(function () {}); } catch (e) {}
    try { document.fonts.addEventListener('loadingdone', settle); } catch (e) {}
    // Belt and braces: a few cheap checks for browsers where neither event fires as expected.
    var n = 0;
    var iv = setInterval(function () {
      n++;
      if (tplFontsAvailable()) { tplRefreshText(); clearInterval(iv); }
      else if (n > 20) clearInterval(iv);
    }, 400);
  }
  function tplEnsureFonts(cb) {
    if (!CFG.template || !(CFG.template.fonts || []).length) { tplFontsReady = true; return cb(); }
    CFG.template.fonts.forEach(function (f) {
      // Preferred path: load the file ourselves. The FontFace promise resolving is the fact we
      // need, with no stylesheet-parse race in between and nothing to infer afterwards.
      if (f.src && window.FontFace && !tplFaceReady[f.family] && !f._pzFaceStarted) {
        f._pzFaceStarted = true;
        try {
          var face = new FontFace(f.family, "url('" + f.src + "')");
          face.load().then(function (ld) {
            document.fonts.add(ld);
            tplFaceReady[f.family] = true;
            tplRefreshText();          // the face arrived late: rebuild in the real thing
          }).catch(function () {});    // fall through to the <link> below
        } catch (e) {}
      }
      if (document.querySelector('link[data-pz-font="' + f.family + '"]')) return;
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = f.url; l.setAttribute('data-pz-font', f.family);
      document.head.appendChild(l);
    });
    if (tplFontsReady && tplFontsAvailable()) return cb();
    var fams = tplFontFamilies().map(function (fam) { return '40px "' + fam + '"'; });
    var fired = false;
    var done = function () { if (fired) return; fired = true; tplFontsReady = true; tplWatchFonts(); cb(); };
    try {
      Promise.all(fams.map(function (s) { return document.fonts.load(s); }))
        .then(function () { return document.fonts.ready; })
        .then(done)
        .catch(done);                      // a missing face must not block the editor
      // Proceed after 4s rather than hang — but tplWatchFonts() then rebuilds the text the moment
      // the face does arrive, so a slow CDN costs a flicker instead of a wrong print file.
      setTimeout(done, 4000);
    } catch (e) { done(); }
  }

  // The frame box in canvas px — every slot hangs off this.
  function tplFrameBox() {
    var t = CFG.template, p = printRectPx();
    var L = (t.layers || [])[0];
    // A template need not have a frame image. The Doll is a background colour and a word, so the
    // "design box" is simply the print area — inset by t.pad (a fraction per side) to keep the
    // artwork comfortably inside the panel rather than running to the trim.
    if (!L) {
      var pad = t.pad || 0;
      return { left: p.left + p.width * pad, top: p.top + p.height * pad,
               width: p.width * (1 - pad * 2), height: p.height * (1 - pad * 2) };
    }
    // Height-first, because that is what survives the cover-fit the original artwork went through:
    // the master is scaled to match plate HEIGHT and cropped on width, so the polaroid occupies the
    // same fraction of the height on every plate. maxW then contains it on wide products, where
    // height alone would run past the edges.
    var h = p.height * (L.h || 0.4352);
    var w = h * L.aspect;
    if (L.maxW && w > p.width * L.maxW) { w = p.width * L.maxW; h = w / L.aspect; }
    return { left: p.left + p.width * L.x - w / 2, top: p.top + p.height * L.y - h / 2, width: w, height: h };
  }
  function tplSlot(id) {
    return (CFG.template.slots || []).filter(function (s) { return s.id === id; })[0];
  }
  // The polaroid calls its text slot 'caption'; other designs will not. Prefer that id so nothing
  // about the polaroid changes, then fall back to the first text slot whatever it is called.
  function tplTextSlot() {
    return tplSlot('caption') || (CFG.template.slots || []).filter(function (s) { return s.kind === 'text'; })[0];
  }
  function tplWindowRect() {
    var fb = tplFrameBox(), o = tplSlot('photo').ofFrame;
    return { left: fb.left + o.x * fb.width, top: fb.top + o.y * fb.height, width: o.w * fb.width, height: o.h * fb.height };
  }

  function tplRemove(pred) {
    fcanvas.getObjects().filter(pred).forEach(function (o) { fcanvas.remove(o); });
  }

  // Place (or replace) the customer's photo in the window: cover-fit, clipped to the window, and
  // sitting UNDER the frame. Under-the-frame alone is not enough — outside the polaroid the frame
  // is transparent, so an oversized photo would spill onto the background.
  function tplSetPhoto(src, cb) {
    tplPhotoSrc = src;
    tplRemove(function (o) { return o._pzSlot === 'photo'; });
    if (!src) { fcanvas.requestRenderAll(); if (cb) cb(); return; }
    var r = tplWindowRect(), slot = tplSlot('photo');
    fabric.Image.fromURL(src, function (img) {
      if (!img || !img.width) { if (cb) cb(); return; }
      var s = Math.max(r.width / img.width, r.height / img.height);
      img.set({
        left: r.left + r.width / 2, top: r.top + r.height / 2, originX: 'center', originY: 'center',
        scaleX: s, scaleY: s,
        selectable: !!slot.move, evented: !!slot.move, hasRotatingPoint: false,
        lockRotation: true, lockScalingFlip: true,
      });
      img.setControlsVisibility({ mtr: false });
      img.clipPath = new fabric.Rect({
        left: r.left, top: r.top, width: r.width, height: r.height,
        originX: 'left', originY: 'top', absolutePositioned: true,
      });
      img._pzSlot = 'photo';
      var st = modal && modal.querySelector('[data-slot-state]');
      if (st) st.textContent = 'Photo added — tap to change';
      fcanvas.add(img);
      tplRestack();
      fcanvas.requestRenderAll(); snapshot();
      if (cb) cb();
    }, { crossOrigin: 'anonymous' });
  }

  function tplSetCaption(text, _retry) {
    var slot = tplTextSlot();
    if (!slot) return;
    // The customer's picks win over the design's defaults; the design's defaults win over nothing.
    var useFont = tplFont || slot.font;
    var useFill = tplFill || slot.fill;
    // stroke, in order of authority: what the customer picked, then the design's default pick,
    // then autoStroke (derive from the fill), then an explicit slot.stroke (the Doll's white
    // outline). Note 'none' is a real choice, so this cannot test truthiness of a colour.
    var useStroke;
    var sOpts = slot.strokeOptions || [];
    if (sOpts.length) {
      var chosen = tplStrokeId || slot.defaultStroke || sOpts[0].id;
      useStroke = tplStrokeOf(sOpts.filter(function (x) { return x.id === chosen; })[0], useFill);
    } else {
      useStroke = slot.autoStroke ? tplAutoStroke(useFill) : slot.stroke;
    }
    var useShadow = null;
    var shOpts = slot.shadowOptions || [];
    if (shOpts.length) {
      var shChosen = tplShadowId || slot.defaultShadow || shOpts[0].id;
      var shOpt = shOpts.filter(function (x) { return x.id === shChosen; })[0];
      if (shOpt) useShadow = shOpt.auto ? tplAutoStroke(useFill) : (shOpt.hex || null);
    }
    // Do not draw in a fallback face and repair later — that is the bug that keeps coming back.
    // Wait for the family, bounded at ~10 attempts (~4s), then draw regardless so a dead font URL
    // degrades to a visible name rather than an empty plate.
    if (useFont && !tplFontsAvailable() && (_retry || 0) < 10) {
      tplCaption = text;
      try { document.fonts.load('40px "' + useFont + '"'); } catch (e) {}
      setTimeout(function () { tplSetCaption(text, (_retry || 0) + 1); }, 400);
      return;
    }
    tplCaption = text;
    tplRemove(function (o) { return o._pzSlot === 'caption'; });
    // TILED NAME. The whole design is the name repeated across the panel, so there is no single
    // hero word to size and centre — a different job from every other text slot, handled before
    // the normal path rather than bolted onto it.
    //
    // Rows are laid out on the PRINT RECT (not the frame box): the pattern is meant to bleed off
    // every edge, so it is drawn past the trim on all sides and the mask clips it. Alternate rows
    // are offset by half a step, which is what stops it reading as a rigid grid.
    if (slot.tile && text) {
      var pr = printRectPx();
      var rowsWanted = slot.tileRows || 7;
      var probe = new fabric.Text(text, { fontFamily: useFont, fontSize: 100 });
      var stepY = pr.height / rowsWanted;
      var size = stepY / (probe.height / 100) * (slot.tileFill || 0.72);
      var sample = new fabric.Text(text, { fontFamily: useFont, fontSize: size });
      var stepX = sample.width + size * (slot.tileGapEm != null ? slot.tileGapEm : 0.6);
      var ang = slot.angle || 0;
      // Overdraw generously so a rotated pattern still covers the corners.
      var over = ang ? 1.6 : 1.15;
      var x0 = pr.left + pr.width / 2 - pr.width * over / 2;
      var y0 = pr.top + pr.height / 2 - pr.height * over / 2;
      var cols = Math.ceil(pr.width * over / stepX) + 2;
      var rows = Math.ceil(pr.height * over / stepY) + 2;
      var group = [];
      for (var r = 0; r < rows; r++) {
        for (var c = 0; c < cols; c++) {
          var tt = new fabric.Text(text, {
            fontFamily: useFont, fill: useFill, fontSize: size,
            originX: 'center', originY: 'center',
            left: x0 + c * stepX + (r % 2 ? stepX / 2 : 0),
            top: y0 + r * stepY,
            selectable: false, evented: false, objectCaching: false,
          });
          group.push(tt);
        }
      }
      var g = new fabric.Group(group, {
        originX: 'center', originY: 'center',
        left: pr.left + pr.width / 2, top: pr.top + pr.height / 2,
        angle: ang, selectable: false, evented: false, objectCaching: false,
      });
      g._pzSlot = 'caption';
      fcanvas.add(g);
      if (!tplFontsAvailable()) { tplFontsWatched = false; tplWatchFonts(); }
      tplRestack();
      fcanvas.requestRenderAll(); snapshot();
      return;
    }
    if (!text) { fcanvas.requestRenderAll(); snapshot(); return; }
    var shown = slot.suffix ? text + slot.suffix : text;
    var fb = tplFrameBox();
    var maxW = slot.ofFrame.w * fb.width;
    var angle = slot.angle || 0;
    var t = new fabric.Text(shown, {
      fontFamily: useFont, fill: useFill,
      originX: 'center', originY: 'center',
      left: fb.left + (slot.ofFrame.cx == null ? 0.5 : slot.ofFrame.cx) * fb.width,
      top: fb.top + slot.ofFrame.y * fb.height,
      angle: angle,
      // A template is read-only unless the slot says otherwise — move, scale and rotate are each
      // opt-in per slot. slot.angle remains the DESIGN's default orientation; rotate only decides
      // whether the customer may turn it from there.
      selectable: !!(slot.move || slot.scale || slot.rotate), evented: !!(slot.move || slot.scale || slot.rotate),
      hasControls: !!(slot.scale || slot.rotate), hasBorders: !!(slot.move || slot.scale || slot.rotate),
      lockMovementX: !slot.move, lockMovementY: !slot.move,
      lockRotation: !slot.rotate, lockScalingFlip: true,
      cornerStyle: 'circle', cornerSize: 22, transparentCorners: false,
      borderColor: '#161616', cornerColor: '#ffffff', cornerStrokeColor: '#161616',
      // NO charSpacing. Fabric's charSpacing separates every CHARACTER, and on a joined script that
      // breaks the connecting strokes — the letterforms stop meeting and it reads as a broken font
      // rather than handwriting. A script face's spacing is the face's own business.
    });
    // Outline. strokeEm is a fraction of the FONT SIZE, not a pixel value, so the outline keeps its
    // proportion as the name shrinks to fit — a fixed width would swallow a long name whole.
    // paintFirst 'stroke' puts the outline behind the fill, which is what makes the face read
    // cleanly instead of the stroke eating half of every letter.
    if (useStroke) {
      t.set({ stroke: useStroke, paintFirst: 'stroke', strokeLineJoin: 'round', strokeLineCap: 'round', strokeUniform: false });
    }
    // Fit. A rotated word is constrained by the box's OTHER axis, so compare against the right one.
    var rot = Math.abs(angle % 180) === 90;
    var limW = rot ? (slot.ofFrame.h || 1) * fb.height : maxW;
    var limH = rot ? maxW : (slot.ofFrame.h || 1) * fb.height;
    var target = (slot.fitH ? fb.height * slot.fitH : fb.height * 0.085);
    if (rot && slot.fitH) target = fb.width * slot.fitH;
    // inkFit: treat fitH as the height the INK should occupy, not the line box. Opt-in per slot so
    // the polaroid's caption sizing is bit-for-bit unchanged.
    if (slot.inkFit) {
      var ratio = tplInkRatio(useFont, text.charAt(0));
      if (ratio && ratio > 0.05) target = target / ratio;
    }
    t.set({ fontSize: target });
    if (useStroke) t.set({ strokeWidth: target * (slot.strokeEm || 0.17) });
    // With inkFit the line box is deliberately taller than the limit — that is the whole point —
    // so the containment test has to measure the ink too, or it would shrink straight back.
    var overH = function () {
      if (!slot.inkFit) return t.height > limH;
      var rr = tplInkRatio(useFont, text.charAt(0));
      return rr ? t.fontSize * rr > limH : t.height > limH;
    };
    for (var i = 0; i < 60 && (t.width > limW || overH()); i++) {
      target *= 0.94;
      t.set({ fontSize: target });
      if (useStroke) t.set({ strokeWidth: target * (slot.strokeEm || 0.17) });
    }
    // Keep whatever the customer moved/resized it to. tplSetCaption re-creates the object on every
    // keystroke, so without this their placement would snap back to the default mid-word.
    if (tplTextXform) {
      if (tplTextXform.left != null) t.set({ left: tplTextXform.left, top: tplTextXform.top });
      if (tplTextXform.scaleX != null) t.set({ scaleX: tplTextXform.scaleX, scaleY: tplTextXform.scaleY });
      if (tplTextXform.angle != null) t.set({ angle: tplTextXform.angle });
    }
    if (useShadow) {
      // blur 0 with an offset is the hard block shadow; blur with NO offset is a glow. One
      // property decides which, so a neon design and a pop design share the same picker.
      var glowEm = slot.glowEm || 0;
      t.set('shadow', new fabric.Shadow({ color: useShadow,
        blur: glowEm ? t.fontSize * glowEm : 0,
        offsetX: glowEm ? 0 : t.fontSize * (slot.shadowEm || 0.08),
        offsetY: glowEm ? 0 : t.fontSize * (slot.shadowEm || 0.08) }));
    }
    t._pzSlot = 'caption';
    if (slot.move || slot.scale || slot.rotate) {
      t.on('modified', function () {
        tplTextXform = { left: t.left, top: t.top, scaleX: t.scaleX, scaleY: t.scaleY, angle: t.angle };
        snapshot();
      });
    }
    // If the face is not rasterisable yet this object carries fallback metrics; watch and rebuild.
    // Re-arm rather than relying on a one-shot: the watcher clears its own interval, so a template
    // rendered a second time would otherwise have nothing watching for the font.
    if (!tplFontsAvailable()) { tplFontsWatched = false; tplWatchFonts(); }
    fcanvas.add(t);
    // Select it on load so the handles are visible and it reads as movable/resizable rather than
    // looking like fixed artwork. Only when the slot actually allows it.
    if (slot.move || slot.scale || slot.rotate) { fcanvas.setActiveObject(t); }
    tplRestack();
    fcanvas.requestRenderAll(); snapshot();
  }

  // z-order is part of the design, so re-assert it after every change rather than trusting
  // insertion order: background, photo, frame, caption.
  function tplRestack() {
    var byId = function (pred) { return fcanvas.getObjects().filter(pred); };
    byId(function (o) { return o._pzTpl === 'bg'; }).forEach(function (o) { fcanvas.sendToBack(o); });
    // The plate goes BELOW the template background and stays there. It is tagged _pzGuide (that is
    // what keeps it out of the print file), so the guide sweep at the end of this function used to
    // drag it to the front and lay 8% black over the whole design.
    byId(function (o) { return o._pzPlate; }).forEach(function (o) { fcanvas.sendToBack(o); });
    byId(function (o) { return o._pzSlot === 'photo'; }).forEach(function (o) { fcanvas.bringToFront(o); });
    byId(function (o) { return o._pzTpl === 'frame'; }).forEach(function (o) { fcanvas.bringToFront(o); });
    byId(function (o) { return o._pzSlot === 'caption'; }).forEach(function (o) { fcanvas.bringToFront(o); });
    byId(function (o) { return o._pzGuide && !o._pzPlate; }).forEach(function (o) { fcanvas.bringToFront(o); });
  }

  // The chosen background artwork, laid across the whole print area. Distinct from t.background,
  // which is a flat colour the design fixes; this is the customer's pick out of a set.
  //
  // COVER, not contain, and clipped to the print rect. One artwork has to serve 101 phone plates of
  // differing aspect: contain would leave bare plate down the sides of the tall ones, and an
  // unclipped cover would push stripes out past the trim on the wide ones.
  /* ── facescatter: the face-sticker pattern products ────────────────────────────────
     Photo -> unsigned Cloudinary upload (the preset returns face coordinates) -> the
     e_background_removal cutout -> jaw-curve head isolation -> sticker outline -> seeded
     lattice of rotated heads, laid over the chosen background colour. The heavy lifting all
     happens in canvas; the pattern lands on fabric as one locked image tagged _pzSlot='photo'
     so every existing save/export/clear path treats it as the photo layer. */
  // petscatter is facescatter's sibling: same cutout -> sticker -> seeded lattice, but the
  // subject box comes from the background-removal alpha, because Cloudinary's face detector
  // only ever finds HUMAN faces. Every branch below tests the pair, never the one mode.
  var fsSticker = null, fsSeed = 1;
  function fsMode() { return (CFG.template && CFG.template.mode) || ''; }
  function fsIsScatter() { var m = fsMode(); return m === 'facescatter' || m === 'petscatter'; }
  function fsIsPet() { return fsMode() === 'petscatter'; }
  function fsSizeFrac() {
    var slot = tplSlot('size');
    if (!slot) return 0.26;
    var id = tplChoice['size'] || slot.default;
    var o = (slot.options || []).filter(function (x) { return x.id === id; })[0];
    return (o && o.value) || 0.26;
  }
  function fsLoadCutout(pid, attempt) {
    // background removal is asynchronous on Cloudinary's side: the first request can fail
    // while it processes, so poll the delivery URL rather than trusting one load.
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () {
        if (attempt >= 12) return reject(new Error('cutout timeout'));
        setTimeout(function () { fsLoadCutout(pid, attempt + 1).then(resolve, reject); }, 1600);
      };
      img.src = 'https://res.cloudinary.com/' + CFG.cloudName + '/image/upload/e_background_removal/' + pid + '.png' + (attempt ? '?r=' + attempt : '');
    });
  }
  function fsMakeSticker(img, face) {
    var W = img.naturalWidth, H = img.naturalHeight;
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0);
    var im = x.getImageData(0, 0, W, H), d = im.data;
    // No face box = PET: treat the whole frame as the subject window, so colMin/colMax below
    // open to the full image and the content-bounds scan that follows becomes a tight alpha
    // bounding box of everything background removal kept.
    var petMode = !face;
    var fx = petMode ? 0 : face[0], fy = petMode ? 0 : face[1],
        fw = petMode ? W : face[2], fh = petMode ? H : face[3];
    // Jaw-curve cut: an elliptical dome, deepest at the chin centre, rising to under-ear
    // height at the sides — a straight line either slices the chin or keeps neck.
    var cx0 = fx + fw / 2, rx = fw * 0.62;
    var yCentre = fy + fh * 1.05, ySide = fy + fh * 0.72;
    var colMin = Math.max(0, Math.round(fx - fw * 0.85)), colMax = Math.min(W - 1, Math.round(fx + fw * 1.85));
    for (var y = 0; y < H; y++) for (var px = 0; px < W; px++) {
      var i = (y * W + px) * 4;
      if (d[i + 3] < 30) { d[i + 3] = 0; continue; }   // residual background haze
      // A pet stops here: haze clamped, subject kept whole. The jaw dome would slice off a
      // snout, ears, or most of a body-on dog, none of which follow a human chin curve.
      if (petMode) continue;
      var dx = (px - cx0) / rx;
      var bound = Math.abs(dx) >= 1 ? ySide : ySide + (yCentre - ySide) * Math.sqrt(1 - dx * dx);
      if (y > bound || px < colMin || px > colMax) d[i + 3] = 0;
    }
    x.putImageData(im, 0, 0);
    // content bounds
    var minX = W, maxX = 0, minY = H, maxY = 0;
    for (var y2 = 0; y2 < H; y2++) for (var x2 = colMin; x2 <= colMax; x2++) {
      if (d[(y2 * W + x2) * 4 + 3] > 40) {
        if (x2 < minX) minX = x2; if (x2 > maxX) maxX = x2;
        if (y2 < minY) minY = y2; if (y2 > maxY) maxY = y2;
      }
    }
    if (maxX <= minX || maxY <= minY) throw new Error('empty head');
    var hw = maxX - minX + 1, hh = maxY - minY + 1;
    var head = document.createElement('canvas'); head.width = hw; head.height = hh;
    head.getContext('2d').drawImage(c, minX, minY, hw, hh, 0, 0, hw, hh);
    // white sticker outline: 16 white-tinted stamps on a circle, then the head on top
    var OUT = Math.max(3, Math.round(hw * 0.045));
    var white = document.createElement('canvas'); white.width = hw; white.height = hh;
    var wx = white.getContext('2d');
    wx.drawImage(head, 0, 0);
    wx.globalCompositeOperation = 'source-in';
    wx.fillStyle = '#ffffff'; wx.fillRect(0, 0, hw, hh);
    var st = document.createElement('canvas'); st.width = hw + OUT * 4; st.height = hh + OUT * 4;
    var sx = st.getContext('2d');
    for (var k = 0; k < 16; k++) {
      var a = k * Math.PI / 8;
      sx.drawImage(white, Math.round(OUT * 2 + Math.cos(a) * OUT), Math.round(OUT * 2 + Math.sin(a) * OUT));
    }
    sx.drawImage(head, OUT * 2, OUT * 2);
    fsSticker = st;
  }
  function fsBuild(cb) {
    if (!fsSticker) { if (cb) cb(); return; }
    var p = printRectPx();
    var PW = 1400, PH = Math.round(PW * p.height / p.width);
    var c = document.createElement('canvas'); c.width = PW; c.height = PH;
    var x = c.getContext('2d');
    var frac = fsSizeFrac();
    var hw = Math.round(PW * frac), hh = Math.round(hw * fsSticker.height / fsSticker.width);
    // full 360-degree rotation, so the safe envelope is the diagonal; pitch = diagonal + gap
    // and zero jitter = perfectly even spacing that can never touch.
    var diag = Math.ceil(Math.sqrt(hw * hw + hh * hh)), gap = Math.round(hw * 0.30);
    var pitch = diag + gap;
    var seed = fsSeed;
    var rng = function () { seed |= 0; seed = (seed + 0x6D2B79F5) | 0;
      var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
    for (var row = -1; row * pitch < PH + diag; row++) {
      for (var col = -1; col * pitch < PW + diag; col++) {
        var ang = rng() * Math.PI * 2;
        var cx = col * pitch + (row % 2 ? pitch / 2 : 0) + hw / 2;
        var cy = row * pitch + hh / 2;
        x.save(); x.translate(cx, cy); x.rotate(ang);
        x.drawImage(fsSticker, -hw / 2, -hh / 2, hw, hh); x.restore();
      }
    }
    tplRemove(function (o) { return o._pzSlot === 'photo'; });
    fabric.Image.fromURL(c.toDataURL('image/png'), function (img) {
      if (img && img.width) {
        img.set({ left: p.left, top: p.top, originX: 'left', originY: 'top',
          scaleX: p.width / img.width, scaleY: p.height / img.height,
          selectable: false, evented: false });
        img._pzSlot = 'photo';
        fcanvas.add(img); tplRestack(); fcanvas.requestRenderAll(); snapshot();
      }
      var stl = modal && modal.querySelector('[data-slot-state]');
      if (stl) stl.textContent = 'Photo added \u2014 tap to change';
      if (cb) cb();
    });
  }
  function fsProcessUpload(file) {
    loading(true, fsIsPet() ? 'Cutting out your pet\u2026' : 'Cutting out the head\u2026');
    var fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', CFG.uploadPreset);
    fetch('https://api.cloudinary.com/v1_1/' + CFG.cloudName + '/image/upload', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d.public_id) throw new Error('upload failed');
        // A pet has no detectable face, so there is nothing to require and nothing to sort:
        // null tells fsMakeSticker to derive the box from the cut-out's alpha instead.
        var face = null;
        if (!fsIsPet()) {
          if (!d.faces || !d.faces.length) { var e = new Error('no face'); e.noFace = true; throw e; }
          face = d.faces.slice().sort(function (a, b) { return b[2] * b[3] - a[2] * a[3]; })[0];
        }
        fsSeed = 0;
        for (var i = 0; i < d.public_id.length; i++) fsSeed = (fsSeed * 31 + d.public_id.charCodeAt(i)) | 0;
        tplPhotoSrc = d.public_id;
        return fsLoadCutout(d.public_id, 0).then(function (img) { fsMakeSticker(img, face); });
      })
      .then(function () { fsBuild(function () { loading(false); }); })
      .catch(function (e) {
        loading(false);
        alert(e && e.noFace ? 'We couldn\u2019t find a face in that photo. Try a clearer, front-facing one.'
                            : 'Could not process that photo. Please try again.');
      });
  }

  // Paint the two-stop gradient across the whole print rect. Synchronous — nothing to fetch — so
  // switching stops is instant, which is what makes a free colour picker usable rather than laggy.
  function tplDrawGradient(slot) {
    if (tplGradFrom === null) tplGradFrom = slot.defaultFrom || (slot.options && slot.options[0] && slot.options[0].from) || '#FFFFFF';
    if (tplGradTo === null) tplGradTo = slot.defaultTo || (slot.options && slot.options[0] && slot.options[0].to) || '#000000';
    var p = printRectPx();
    tplRemove(function (o) { return o._pzTpl === 'bg'; });
    var r = new fabric.Rect({
      left: p.left, top: p.top, width: p.width, height: p.height,
      originX: 'left', originY: 'top', selectable: false, evented: false,
    });
    // fabric 5 removed setGradient — the theme ships 5.3.0, so it is the Gradient constructor.
    // gradientUnits 'pixels' with coords in the object's own space, hence 0..height not 0..1.
    r.set('fill', new fabric.Gradient({
      type: 'linear', gradientUnits: 'pixels',
      coords: { x1: 0, y1: 0, x2: 0, y2: p.height },   // vertical, top stop to bottom stop
      colorStops: [{ offset: 0, color: tplGradFrom }, { offset: 1, color: tplGradTo }],
    }));
    r._pzTpl = 'bg';
    fcanvas.add(r);
    tplRestack();
    fcanvas.requestRenderAll(); snapshot();
  }

  function tplSetBgChoice(cb) {
    // A gradient background is drawn, not loaded — handle it before the image path.
    var gs = (CFG.template.slots || []).filter(function (s) { return s.kind === 'gradient'; })[0];
    if (gs) { tplDrawGradient(gs); if (cb) cb(); return; }
    var slot = tplChoiceSlots().filter(function (s) { return (s.render || 'background') === 'background'; })[0];
    if (!slot) { if (cb) cb(); return; }
    var opt = tplOption(slot, tplChoice[slot.id] || slot.default);
    if (!opt || !opt.src) { if (cb) cb(); return; }
    tplChoice[slot.id] = opt.id;
    var p = printRectPx();
    fabric.Image.fromURL(opt.src, function (img) {
      if (!img || !img.width) { if (cb) cb(); return; }
      // Remove the OLD background only once the new one has decoded, so switching swatches never
      // flashes an empty plate.
      tplRemove(function (o) { return o._pzTpl === 'bg'; });
      var s = Math.max(p.width / img.width, p.height / img.height);
      img.set({
        left: p.left + p.width / 2, top: p.top + p.height / 2, originX: 'center', originY: 'center',
        scaleX: s, scaleY: s, selectable: false, evented: false,
      });
      img.clipPath = new fabric.Rect({
        left: p.left, top: p.top, width: p.width, height: p.height,
        originX: 'left', originY: 'top', absolutePositioned: true,
      });
      img._pzTpl = 'bg';
      fcanvas.add(img);
      tplRestack();
      fcanvas.requestRenderAll(); snapshot();
      if (cb) cb();
    }, { crossOrigin: 'anonymous' });
  }

  // Build the whole template onto the current plate. Called instead of the base-design branch.
  function applyTemplateLayers(done) {
    var t = CFG.template;
    tplEnsureFonts(function () {
      var p = printRectPx();
      tplRemove(function (o) { return o._pzTpl || o._pzSlot; });
      // No background means TRANSPARENT, not white. On a mug or a shirt the product's own surface
      // is the background; printing a white rect would lay white ink across the whole panel.
      if (t.background) {
        var bg = new fabric.Rect({
          left: p.left, top: p.top, width: p.width, height: p.height, fill: t.background,
          originX: 'left', originY: 'top', selectable: false, evented: false,
        });
        bg._pzTpl = 'bg';
        fcanvas.add(bg);
      }
      var fb = tplFrameBox();
      // Frameless template (a background and a word): nothing to load, go straight to the slots.
      if (!(t.layers || []).length) {
        tplLoaded = true;
        var cap0 = tplTextSlot();
        if (cap0 && tplCaption === null) tplCaption = cap0.default || '';
        if (cap0 && tplFont === null) tplFont = cap0.defaultFont || cap0.font || null;
        if (cap0 && tplFill === null) tplFill = cap0.defaultFill || cap0.fill || null;
        // The background is an image load, so the caption has to wait for it — otherwise the text
        // is drawn, then the artwork arrives and tplRestack sends it to back over nothing.
        tplSetBgChoice(function () {
          tplSetCaption(tplCaption);
          if (fsIsScatter() && fsSticker) { fsBuild(function () { tplRestack(); done(); }); }
          else { tplRestack(); done(); }
        });
        return;
      }
      fabric.Image.fromURL(t.layers[0].src, function (fr) {
        if (fr && fr.width) {
          fr.set({
            left: fb.left, top: fb.top, originX: 'left', originY: 'top',
            scaleX: fb.width / fr.width, scaleY: fb.height / fr.height,
            selectable: false, evented: false,
          });
          fr._pzTpl = 'frame';
          fcanvas.add(fr);
        }
        tplLoaded = true;
        var cap = tplTextSlot();
        if (cap && tplCaption === null) tplCaption = cap.default || '';
        if (tplPhotoSrc) tplSetPhoto(tplPhotoSrc, function () { tplSetCaption(tplCaption); tplRestack(); done(); });
        else { tplSetCaption(tplCaption); tplRestack(); done(); }
      }, { crossOrigin: 'anonymous' });
    });
  }

  function applyMaskEntry(mk, opts) {
    var isFlatProduct = !!(opts && opts.flat);
    pzUsedMask = true;
    pzPlateSrc = mk.mask; pzPlateSide = currentSide();
    loading(true);
    PIPE = 'placed'; MODE = 'overlay'; FRAMEFIT = 0; VIEWCROP = null; CASE_HARD = null;
    var fw = mk.frame[0], fh = mk.frame[1];
    // BLEED. A mask is cropped to its own alpha bounds, so without this the export is
    // panel-tight and the press has zero tolerance. When the mask carries its physical size,
    // grow the ARTBOARD past the panel by bleedMm on every edge: the mask (clip + plate +
    // guide) is inset so it still marks the true panel, and PRINT becomes the whole artboard
    // so the extra artwork lands in the print file. No bleedMm -> every value below collapses
    // to the old behaviour, which is what keeps the phone plates untouched.
    var bfx = 0, bfy = 0;
    if (mk.bleedMm && mk.printMm && mk.printMm[0] && mk.printMm[1]) {
      bfx = mk.bleedMm / mk.printMm[0];
      bfy = mk.bleedMm / mk.printMm[1];
    }
    var maskW = AW / (1 + 2 * bfx);
    var maskH = maskW * fh / fw;
    AH = Math.round(maskH * (1 + 2 * bfy));
    var mx = (AW - maskW) / 2, my = (AH - maskH) / 2;
    if (bfx || bfy) PRINT = [0, 0, 1, 1];
    else PRINT = [mk.bbox[0] / fw, mk.bbox[1] / fh, mk.bbox[2] / fw, mk.bbox[3] / fh];
    var render = function () { drawGuides(); fitBoard(); fcanvas.requestRenderAll(); loading(false); snapshot(); };
    fabric.Image.fromURL(mk.mask, function (mi) {
      // Mask unloadable → fall back. Phone products have a legacy case-render path;
      // product-type masks have none, so degrade to the normal mockup pipeline instead.
      if (!mi || !mi.width) { if (isFlatProduct) { CFG.flatMask = null; applyEntry(); } else { applyCustomPhoneEntryLegacy(); } return; }
      var sc = maskW / mi.width;
      mi.set({ left: mx, top: my, originX: 'left', originY: 'top', scaleX: sc, scaleY: sc, absolutePositioned: true });
      fcanvas.clipPath = mi;                                            // everything renders inside the plate
      fabric.Image.fromURL(mk.mask, function (bd) {
        fcanvas.setOverlayImage(null, function () {});
        fcanvas.setBackgroundImage(null, function () {});
        fcanvas.getObjects().filter(function (o) { return o._pzPlate; }).forEach(function (o) { fcanvas.remove(o); });
        // Apparel: the plate stands in for the GARMENT, so it takes the shirt's own colour —
        // the customer is judging their artwork against what they will actually receive. The
        // canvas clipPath already limits drawing to the mask, so a rect over the artboard paints
        // exactly the plate shape. _pzGuide keeps it out of the print file, which stays transparent.
        var garment = isFlatProduct ? garmentColour() : null;
        if (garment) {
          var gp = new fabric.Rect({ left: 0, top: 0, width: AW, height: AH, fill: garment,
            selectable: false, evented: false, objectCaching: false, excludeFromExport: true });
          gp._pzGuide = true; gp._pzPlate = true;
          fcanvas.add(gp); fcanvas.sendToBack(gp);
        }
        if (bd && bd.width && !garment) {
          // Backdrop = the plate itself, drawn behind the artwork to show the printable region.
          // Never exported (_pzGuide), so nothing here can reach a print file.
          bd.set({ left: mx, top: my, originX: 'left', originY: 'top', scaleX: maskW / bd.width, scaleY: maskW / bd.width, selectable: false, evented: false });
          // ALWAYS pale, whatever the colour side. The mask art is #161616, so the Black and
          // MagSafe plates used to render at full opacity and turn the whole design area black —
          // the customer could not see their own artwork, and dark designs disappeared entirely.
          // The plate is a guide, not a preview of the product.
          bd.opacity = 0.08;
          bd._pzGuide = true; bd._pzPlate = true;
          fcanvas.add(bd); fcanvas.sendToBack(bd);
        }
        // Dashed red print-area guide. It is a _pzGuide, so exportArt hides it and it can never
        // reach the print file. Drawn BEFORE the stock-design branch below, which returns early —
        // that return is why stock backpacks previously showed no guide at all.
        // mk.outline is traced at ingest (fractions of the frame); without one, fall back to the
        // print rect so a white design or an empty DYO still shows where the printable area is.
        function drawPrintGuide() {
          fcanvas.getObjects().filter(function (o) { return o._pzPrintGuide; }).forEach(function (o) { fcanvas.remove(o); });
          var guide;
          var opts = { fill: '', stroke: '#f03e2e', strokeWidth: 3, strokeDashArray: [10, 5],
            strokeUniform: true, selectable: false, evented: false, objectCaching: false, excludeFromExport: true };
          // fcanvas.clipPath (the mask) clips EVERY object, so a stroke sitting exactly on the
          // boundary loses its outer half and the dashes read as cut off. The traced outline is
          // inset horizontally at ingest but not vertically, so pull every point toward the
          // centroid here — that insets both axes and works for any mask shape.
          var pad = Math.max(4, Math.round(Math.min(AW, AH) * 0.006));
          // SAFE AREA. Where a mask carries one, the guide marks what the customer will SEE rather
          // than what will print — the pencil case's fold and the notebook's wire strip are both
          // printed and then hidden. Nothing else changes: the clip, PRINT and the export still
          // cover the whole mask, so ink reaches the hidden parts as it must.
          //
          // (opts and pad are declared ABOVE this branch deliberately: the original version read
          // them before their `var` assignments ran, so the safe rect had NaN geometry and no
          // stroke — on the pencil case the customer saw no guide at all.)
          //
          // Three parts, all _pzGuide so none can reach the print file:
          //   scrims     the hidden zones, dimmed, so they read as "not yours to design in"
          //   fold line  a solid red rule on each edge where a hidden zone meets the safe area
          //   label      what happens there, in the largest hidden zone (mk.safeNote per product)
          if (mk.safe) {
            var sp = (bfx || bfy) ? { left: mx, top: my, width: maskW, height: maskH } : printRectPx();
            var sx = sp.left + mk.safe.x * sp.width, sy = sp.top + mk.safe.y * sp.height;
            var sw = mk.safe.w * sp.width, sh = mk.safe.h * sp.height;
            var zones = [];
            if (mk.safe.y > 0.02) zones.push({ left: sp.left, top: sp.top, width: sp.width, height: sy - sp.top, edge: 'bottom' });
            if (mk.safe.y + mk.safe.h < 0.98) zones.push({ left: sp.left, top: sy + sh, width: sp.width, height: sp.top + sp.height - (sy + sh), edge: 'top' });
            if (mk.safe.x > 0.02) zones.push({ left: sp.left, top: sy, width: sx - sp.left, height: sh, edge: 'right' });
            if (mk.safe.x + mk.safe.w < 0.98) zones.push({ left: sx + sw, top: sy, width: sp.left + sp.width - (sx + sw), height: sh, edge: 'left' });
            var mark = function (o) { o._pzGuide = true; o._pzPrintGuide = true; fcanvas.add(o); fcanvas.bringToFront(o); };
            zones.forEach(function (z) {
              mark(new fabric.Rect({ left: z.left, top: z.top, width: z.width, height: z.height,
                fill: 'rgba(22,22,22,0.10)', selectable: false, evented: false, objectCaching: false, excludeFromExport: true }));
              // the fold/boundary line, on the zone edge shared with the safe area
              var x1 = z.left, y1 = z.top, x2 = z.left + z.width, y2 = z.top + z.height;
              if (z.edge === 'bottom') y1 = y2; else if (z.edge === 'top') y2 = y1;
              else if (z.edge === 'right') x1 = x2; else x2 = x1;
              mark(new fabric.Line([x1, y1, x2, y2], { stroke: '#f03e2e', strokeWidth: 3, strokeDashArray: [14, 7],
                strokeUniform: true, selectable: false, evented: false, objectCaching: false, excludeFromExport: true }));
            });
            var big = zones.slice().sort(function (a, b) { return b.width * b.height - a.width * a.height; })[0];
            if (big && Math.min(big.width, big.height) > 26) {
              var note = mk.safeNote || 'Printed, but hidden here \u2014 fill it too';
              var upright = big.height > big.width * 1.6;
              mark(new fabric.Text(note, {
                left: big.left + big.width / 2, top: big.top + big.height / 2,
                originX: 'center', originY: 'center', angle: upright ? -90 : 0,
                textAlign: 'center', lineHeight: 1.25,
                fontFamily: "'Nunito', sans-serif", fontWeight: '700',
                fontSize: Math.max(12, Math.min(sp.width, sp.height) * 0.032),
                fill: 'rgba(22,22,22,0.55)',
                selectable: false, evented: false, objectCaching: false, excludeFromExport: true,
              }));
            }
            var sg = new fabric.Rect(Object.assign({
              left: sx + pad, top: sy + pad, width: sw - pad * 2, height: sh - pad * 2, rx: 4, ry: 4,
            }, opts));
            mark(sg);
            if (!pzSafeHinted) { pzSafeHinted = true; hint('Fill the whole shape \u2014 the shaded part still prints. Just keep faces and words inside the dotted line'); }
            return;
          }
          if (mk.outline && mk.outline.length > 2) {
            var pts = mk.outline.map(function (p) { return { x: mx + p[0] * maskW, y: my + p[1] * maskH }; });
            var cx = 0, cy = 0;
            pts.forEach(function (p) { cx += p.x; cy += p.y; });
            cx /= pts.length; cy /= pts.length;
            pts = pts.map(function (p) {
              var dx = p.x - cx, dy = p.y - cy, d = Math.sqrt(dx * dx + dy * dy) || 1;
              return { x: p.x - dx / d * pad, y: p.y - dy / d * pad };
            });
            guide = new fabric.Polygon(pts, opts);
          } else {
            var pr = (bfx || bfy) ? { left: mx, top: my, width: maskW, height: maskH } : printRectPx();
            // No authored outline — trace the mask we just loaded. The trace returns fractions of
            // the MASK IMAGE, so it must be mapped onto the box the mask is drawn in, NOT onto pr.
            // They are the same box for flat product masks (bbox is the whole frame) but NOT for
            // phone plates, where a GoBear bbox is a sub-rect of the frame — mapping onto pr there
            // squashed the silhouette into that sub-rect and floated it inside the plate.
            var tr = traceMaskOutline((bd && bd._element) || (mi && mi._element));
            if (tr) {
              var tp = tr.map(function (p) { return { x: mx + p.x * maskW, y: my + p.y * maskH }; });
              var tcx = 0, tcy = 0;
              tp.forEach(function (p) { tcx += p.x; tcy += p.y; });
              tcx /= tp.length; tcy /= tp.length;
              tp = tp.map(function (p) {
                var dx = p.x - tcx, dy = p.y - tcy, dd = Math.sqrt(dx * dx + dy * dy) || 1;
                return { x: p.x - dx / dd * pad, y: p.y - dy / dd * pad };
              });
              guide = new fabric.Polygon(tp, opts);
            } else {
              // Last resort: tainted canvas or an image that never decoded. A rounded rect is
              // wrong at the corners, but a guide in roughly the right place beats none at all.
              guide = new fabric.Rect(Object.assign({ left: pr.left + pad, top: pr.top + pad, width: pr.width - pad * 2, height: pr.height - pad * 2, rx: 6, ry: 6 }, opts));
            }
          }
          guide._pzGuide = true; guide._pzPrintGuide = true;
          fcanvas.add(guide);
          fcanvas.bringToFront(guide);
        }
        drawPrintGuide();
        // Stock designs (backpacks, lunchboxes…) carry existing artwork the customer adds
        // to — COVER-fit it to the print rect as a locked base layer. DYO / Custom Photo
        // have no base design, so the plate simply starts empty.
        // Base design on the plate. Was flat-products-only; phone plates need it too now that
        // design-backed cases are mask-driven — otherwise the plate would open empty and the
        // customer would lose the design they picked.
        // A template owns the whole plate — background, artwork and slots — so it replaces the
        // base-design branch entirely rather than layering on top of it.
        // No layers-length test: a template owns the plate whether or not it has a frame image.
        // The Doll is a background and a word; gating on layers.length left it with an empty canvas.
        if (CFG.template) {
          applyTemplateLayers(function () { render(); });
          return;
        }
        if (CFG.baseDesign && !baseLoaded) {
          fabric.Image.fromURL(CFG.baseDesign, function (dimg) {
            if (dimg && dimg.width) {
              var p = printRectPx();
              var s = Math.max(p.width / dimg.width, p.height / dimg.height);
              dimg.set({ left: p.left + p.width / 2, top: p.top + p.height / 2, originX: 'center', originY: 'center', scaleX: s, scaleY: s, selectable: false, evented: false });
              dimg._pzBase = true; baseLoaded = true;
              fcanvas.add(dimg); fcanvas.sendToBack(dimg);
              fcanvas.getObjects().filter(function (o) { return o._pzPlate; }).forEach(function (g) { fcanvas.sendToBack(g); });
            }
            render();
          }, { crossOrigin: 'anonymous' });
          return;
        }
        render();
      }, { crossOrigin: 'anonymous' });
    }, { crossOrigin: 'anonymous' });
  }
  // DYO / Custom-Photo, in-house case type. Show the case centred in a SQUARE frame (like a standard
  // design's clean square) and crop the export to the case rect. NO view-crop is used, so exportArt
  // crops correctly (same proven path garments use: PRINT set, viewport un-panned).
  function applyCustomPhoneEntry() {
    var mk = maskEntryForSelection();
    if (mk) { applyMaskEntry(mk); return; }
    applyCustomPhoneEntryLegacy();
  }
  function applyCustomPhoneEntryLegacy() {
    loading(true);
    PIPE = 'placed';                 // saves through finishPlaced (exportArt) — the proven path
    MODE = 'overlay';
    FRAMEFIT = 0;
    VIEWCROP = null;                 // no view-crop → exportArt's crop origin stays correct
    var pc = phoneCase();
    CASE_LID = pc ? pc.lid : null;
    var render = function () { drawGuides(); fitBoard(); fcanvas.requestRenderAll(); loading(false); snapshot(); };
    if (!CASE_LID) { AH = Math.round(AW / (CFG.aspect || 0.5)); PRINT = null; fcanvas.setBackgroundImage(null, function () {}); fcanvas.setOverlayImage(null, render); return; }
    // Measure the tight (e_trim) case aspect, then centre it in a square. c_pad puts a tall case at
    // [(1-ar)/2, 0, ar, 1] of the square, so PRINT = the case rect → the export is the case front.
    fabric.Image.fromURL(pc.url, function (ci) {
      var caseAR = (ci && ci.width && ci.height) ? (ci.width / ci.height) : 0.5;
      if (caseAR > 1) caseAR = 1;
      AH = AW;                                       // square board
      PRINT = [(1 - caseAR) / 2, 0, caseAR, 1];      // case rect within the square = the print area
      var ovUrl = 'https://res.cloudinary.com/' + CFG.cloudName + '/image/upload/e_trim/w_1000,h_1000,c_pad,g_center/f_png/' + CASE_LID;
      fabric.Image.fromURL(ovUrl, function (oc) {
        fcanvas.setBackgroundImage(null, function () {
          if (!oc || !oc.width) { fcanvas.setOverlayImage(null, render); return; }
          // Measure the case's HARD silhouette (median alpha>=150 bounds). e_trim keeps the
          // nearly-transparent outer walls of clear/white renders, so the raw bounds overshoot
          // the visible edge — a cover-fitted photo then looks like it spills past the bezel.
          // The photo's VISUAL clip uses these bounds; the export still bleeds to PRINT.
          CASE_HARD = null;
          try {
            var el = oc.getElement(), w = el.naturalWidth || el.width, h = el.naturalHeight || el.height;
            var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
            var cxx = cv.getContext('2d'); cxx.drawImage(el, 0, 0);
            var dd = cxx.getImageData(0, 0, w, h).data;
            var a = function (x, y) { return dd[(y * w + x) * 4 + 3]; };
            var med = function (arr) { if (!arr.length) return null; arr.sort(function (m, n) { return m - n; }); return arr[Math.floor(arr.length / 2)]; };
            // Walk inward from each side: enter the case (alpha>=150), then the first
            // alpha<=40 pixel = the transparent print window's edge. Medians kill the
            // camera cluster / corner-curve outlier rows.
            var Ls = [], Rs = [], Ts = [], Bs = [];
            for (var yy = Math.round(h * 0.2); yy <= Math.round(h * 0.8); yy += 8) {
              var inL = false;
              for (var xa = 0; xa < w; xa++) { var al = a(xa, yy); if (!inL) { if (al >= 150) inL = true; } else if (al <= 40) { Ls.push(xa); break; } }
              var inR = false;
              for (var xb = w - 1; xb >= 0; xb--) { var ar = a(xb, yy); if (!inR) { if (ar >= 150) inR = true; } else if (ar <= 40) { Rs.push(xb); break; } }
            }
            // Columns on the right half of the window dodge the top-left camera cluster.
            for (var xx = Math.round(w * 0.55); xx <= Math.round(w * 0.68); xx += 6) {
              var inT = false;
              for (var ya = 0; ya < h; ya++) { var at = a(xx, ya); if (!inT) { if (at >= 150) inT = true; } else if (at <= 40) { Ts.push(ya); break; } }
              var inB = false;
              for (var yb = h - 1; yb >= 0; yb--) { var ab = a(xx, yb); if (!inB) { if (ab >= 150) inB = true; } else if (ab <= 40) { Bs.push(yb); break; } }
            }
            var L = med(Ls), R = med(Rs), Tt = med(Ts), Bt = med(Bs);
            if (L !== null && R !== null && Tt !== null && Bt !== null && R - L > w * 0.2 && Bt - Tt > h * 0.4) {
              // Outset a touch so the clip edge tucks under the bezel lip (no hairline gap).
              var OUT = 4;
              CASE_HARD = { left: (L - OUT) / w * AW, top: (Tt - OUT) / h * AH, width: (R - L + 1 + OUT * 2) / w * AW, height: (Bt - Tt + 1 + OUT * 2) / h * AH };
            }
          } catch (e) { CASE_HARD = null; /* tainted/unreadable → fall back to the PRINT rect */ }
          oc.set({ selectable: false, evented: false }); oc.scaleToWidth(AW);
          fcanvas.setOverlayImage(oc, render);
        });
      }, { crossOrigin: 'anonymous' });
    }, { crossOrigin: 'anonymous' });
  }
  function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8 = new Uint8Array(n);
    while (n--) u8[n] = bstr.charCodeAt(n);
    return new Blob([u8], { type: mime });
  }
  // Capture ONLY the customer additions (no design, no case, no guides) at the design's native
  // resolution, so Cloudinary can overlay them 1:1 on the real artwork.
  function captureAdditions() {
    fcanvas.discardActiveObject();
    var bg = fcanvas.backgroundImage, ov = fcanvas.overlayImage, bc = fcanvas.backgroundColor;
    // Drop the design/case AND the white canvas fill so the additions PNG is TRANSPARENT
    // (otherwise it would cover the design with white when Cloudinary overlays it).
    fcanvas.backgroundImage = null; fcanvas.overlayImage = null; fcanvas.backgroundColor = '';
    fcanvas.getObjects().forEach(function (o) { if (o._pzGuide) o.visible = false; });
    // Temporarily map the FULL design frame 1:1 at native resolution (ignore the view crop),
    // so the additions land in the same frame Cloudinary composites onto.
    var savedVT = fcanvas.viewportTransform.slice(), savedW = fcanvas.getWidth(), savedH = fcanvas.getHeight();
    // Cap at 4000px: print-res design masters (7500px+) would mean an 89MP canvas in the
    // customer's browser and an 89MP additions upload. fl_relative scales it to the base anyway.
    var s = Math.min(DESIGN_NATIVE_W, 4000) / AW;
    fcanvas.setDimensions({ width: Math.round(AW * s), height: Math.round(AH * s) });
    fcanvas.setViewportTransform([s, 0, 0, s, 0, 0]);
    var data = fcanvas.toDataURL({ format: 'png' });
    fcanvas.setViewportTransform(savedVT); fcanvas.setDimensions({ width: savedW, height: savedH });
    fcanvas.backgroundImage = bg; fcanvas.overlayImage = ov; fcanvas.backgroundColor = bc;
    fcanvas.getObjects().forEach(function (o) { if (o._pzGuide) o.visible = true; });
    fcanvas.requestRenderAll();
    return dataURLtoBlob(data);
  }
  function uploadAdditions(blob) {
    var fd = new FormData();
    fd.append('file', blob);
    fd.append('upload_preset', CFG.uploadPreset);
    return fetch('https://api.cloudinary.com/v1_1/' + CFG.cloudName + '/image/upload', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (!d.public_id) throw new Error('upload failed'); return d.public_id; });
  }
  // Build the two Cloudinary URLs from the uploaded additions layer (folder slashes → colons).
  function buildPhoneUrls(publicId) {
    var base = 'https://res.cloudinary.com/' + CFG.cloudName + '/image/fetch/';
    var add = publicId.replace(/\//g, ':');
    var design = CFG.baseDesignRaw;
    var regionW = Math.round(1000 * DESIGN_ASPECT);
    // Print file: additions overlaid on the design at full relative width — this IS the artwork.
    // c_limit first: print-resolution masters can exceed Cloudinary's 25MP transform limit
    // (89MP masters 400-ed every personalised print URL). ≤4000px ≈ 725dpi on a case — plenty.
    var print = base + 'c_limit,h_4000,w_4000/l_' + add + ',fl_relative,w_1.0,fl_layer_apply/' + design;
    // Preview: the framing MUST lead with c_pad (padding the design into the square product frame);
    // baking the additions before the frame collapses it. So pad the design, overlay the additions
    // in the same region, scale to the case window, apply the case. f_png keeps the surround
    // transparent so there's no white border in the gallery.
    var preview = CASE_LID
      ? base + 'w_1000,h_1000,c_pad,g_center/l_' + add + ',w_' + regionW + ',fl_layer_apply/c_scale,h_940/l_' + CASE_LID + ',fl_layer_apply/f_png/' + design
      : print;
    return { print: print, preview: preview };
  }

  // Standard designs: drop the existing AWS artwork in as a locked base layer for the customer to add to.
  function loadBaseDesign() {
    if (baseLoaded || !CFG.baseDesign) return;
    baseLoaded = true;
    fabric.Image.fromURL(CFG.baseDesign, function (img) {
      if (!img) return;
      var cx = AW / 2, cy = AH / 2, scale;
      if (FRAMEFIT && MODE === 'overlay') {
        // Board is the tight (e_trim) case. The composite contains the design in a 1000² frame
        // with the case at h_(FRAMEFIT*1000); reproduce that scale relative to the case bounds
        // so the artwork sits exactly as Cloudinary places it while the case fills the box.
        var FRAME = 1000, CH = FRAMEFIT * FRAME;
        var dA = img.width / img.height;
        var dFrameW = dA >= 1 ? FRAME : FRAME * dA;      // design width when contained in the frame
        var phoneFrameW = CH * (AW / AH);                // case width within that frame
        scale = (dFrameW * (AW / phoneFrameW)) / img.width;
      } else {
        // Garments (print rect) COVER their rect; other overlay products CONTAIN the board.
        var area = PRINT ? printRectPx() : { left: 0, top: 0, width: AW, height: AH };
        cx = area.left + area.width / 2; cy = area.top + area.height / 2;
        scale = PRINT ? Math.max(area.width / img.width, area.height / img.height)
                      : Math.min(area.width / img.width, area.height / img.height);
      }
      img.set({ left: cx, top: cy, originX: 'center', originY: 'center', scaleX: scale, scaleY: scale, selectable: false, evented: false });
      img._pzBase = true;
      if (MODE === 'print') clipObj(img);
      fcanvas.add(img);
      fcanvas.sendToBack(img);   // above the background, below user additions…
      fcanvas.getObjects().filter(function (o) { return o._pzGuide; }).forEach(function (g) { fcanvas.sendToBack(g); }); // …but the guide stays at the very back
      fcanvas.requestRenderAll();
      snapshot();
    }, { crossOrigin: 'anonymous' });
  }

  function fitBoard() {
    if (!fcanvas) return;
    var stage = modal.querySelector('.pz__stage');
    var availW = stage.clientWidth - 32, availH = stage.clientHeight - 32;
    // Fit the crop rect (phone = case bounds) if set, else the whole board.
    var vw = VIEWCROP ? VIEWCROP.width : AW, vh = VIEWCROP ? VIEWCROP.height : AH;
    var scale = Math.min((availW - BOARD_PAD * 2) / vw, (availH - BOARD_PAD * 2) / vh);
    if (!isFinite(scale) || scale <= 0) scale = 0.3;
    fcanvas.setDimensions({ width: Math.round(vw * scale) + BOARD_PAD * 2, height: Math.round(vh * scale) + BOARD_PAD * 2 });
    var ox = (VIEWCROP ? -VIEWCROP.left * scale : 0) + BOARD_PAD, oy = (VIEWCROP ? -VIEWCROP.top * scale : 0) + BOARD_PAD;
    fcanvas.setViewportTransform([scale, 0, 0, scale, ox, oy]);
    fcanvas.requestRenderAll();
  }

  // Zoom the VIEW (never the element) so the selected object fits alongside the board.
  //
  // A phone case is extremely elongated, so cover-fitting an ordinary photo overflows the width by
  // a large multiple — measured on a reproduction, only 2 of 8 handles landed on the canvas, the
  // top and bottom middles, which is exactly the pair of stray selection lines customers reported.
  // No fixed margin can cover that; the view has to accommodate the object. Board zoom is restored
  // the moment the object is deselected, so the case is shown full size whenever nothing is picked.
  // Both exports read the live viewport, so they stay correct at whatever zoom this leaves behind.
  function fitView() {
    if (!fcanvas) return;
    var a = fcanvas.getActiveObject();
    if (!a) { fitBoard(); return; }
    var vw = VIEWCROP ? VIEWCROP.width : AW, vh = VIEWCROP ? VIEWCROP.height : AH;
    var vx = VIEWCROP ? VIEWCROP.left : 0, vy = VIEWCROP ? VIEWCROP.top : 0;
    var r = a.getBoundingRect(true, true);                 // scene coords, ignoring the viewport
    var x0 = Math.min(vx, r.left), y0 = Math.min(vy, r.top);
    var x1 = Math.max(vx + vw, r.left + r.width), y1 = Math.max(vy + vh, r.top + r.height);
    // Nothing overhangs -> leave the board framing alone rather than nudge it for no reason.
    if (x0 >= vx && y0 >= vy && x1 <= vx + vw && y1 <= vy + vh) { fitBoard(); return; }
    var m = Math.max(x1 - x0, y1 - y0) * 0.05;
    x0 -= m; y0 -= m; x1 += m; y1 += m;
    var cw = fcanvas.getWidth(), ch = fcanvas.getHeight();
    var s = Math.min(cw / (x1 - x0), ch / (y1 - y0));
    if (!isFinite(s) || s <= 0) return;
    fcanvas.setViewportTransform([s, 0, 0, s,
      -x0 * s + (cw - (x1 - x0) * s) / 2,
      -y0 * s + (ch - (y1 - y0) * s) / 2]);
    fcanvas.requestRenderAll();
  }

  /* ---------- history (simple) ---------- */
  function raisePrintGuide() {
    if (!fcanvas) return;
    var g = fcanvas.getObjects().filter(function (o) { return o._pzPrintGuide; })[0];
    if (g) { fcanvas.bringToFront(g); fcanvas.requestRenderAll(); }
  }
  function snapshot() {
    if (restoring) return;
    raisePrintGuide();
    var json = JSON.stringify(fcanvas.toDatalessJSON());
    history = history.slice(0, histIdx + 1);
    history.push(json); histIdx = history.length - 1;
    var u = modal.querySelector('[data-pz-undo]'); if (u) u.disabled = histIdx <= 0;
  }
  function undo() {
    if (histIdx <= 0) return;
    histIdx--; restoring = true;
    fcanvas.loadFromJSON(history[histIdx], function () {
      // re-draw guides (excluded from export/dataless) if lost
      if (!fcanvas.getObjects().some(function (o) { return o._pzGuide; })) drawGuides();
      // Phones keep the design as a background (not a _pzBase object), so skip the reload there.
      if (CFG.baseDesign && !(CFG.isPhone && CFG.baseDesignRaw) && !fcanvas.getObjects().some(function (o) { return o._pzBase; })) { baseLoaded = false; loadBaseDesign(); }
      fcanvas.requestRenderAll(); restoring = false;
      var u = modal.querySelector('[data-pz-undo]'); if (u) u.disabled = histIdx <= 0;
    });
  }

  /* ---------- object helpers ---------- */
  function centreish() { var p = printRectPx(); return { left: p.left + p.width / 2, top: p.top + p.height / 2, originX: 'center', originY: 'center' }; }
  function pw() { return printRectPx().width; }   // scale new elements to the print area, not the whole board
  function addText(str) {
    var t = new fabric.Textbox(str || 'Your text', Object.assign(centreish(), {
      fontFamily: activeFont, fill: activeColour, fontSize: pw() * 0.14, fontWeight: '700', textAlign: 'center', width: pw() * 0.8
    }));
    clipObj(t);
    fcanvas.add(t); fcanvas.setActiveObject(t); fcanvas.requestRenderAll(); snapshot();
    hint('Drag to move · pinch or corner to resize');
  }
  function addSticker(ch) {
    var t = new fabric.Text(ch, Object.assign(centreish(), { fontSize: pw() * 0.28 }));
    clipObj(t);
    fcanvas.add(t); fcanvas.setActiveObject(t); fcanvas.requestRenderAll(); snapshot();
  }
  function addImage(dataUrl) {
    // Upload the photo first and place it from its URL: keeps the saved design state
    // tiny (no base64 in the JSON) and the original photo recoverable for admin edits.
    loading(true);
    var placeFrom = function (src) { loading(false); addImageFrom(src); };
    try {
      uploadAdditions(dataURLtoBlob(dataUrl))
        .then(function (pid) { placeFrom('https://res.cloudinary.com/' + CFG.cloudName + '/image/upload/' + pid); })
        .catch(function () { placeFrom(dataUrl); });   // offline/failed upload → inline fallback
    } catch (e) { placeFrom(dataUrl); }
  }
  function addImageFrom(dataUrl) {
    fabric.Image.fromURL(dataUrl, function (img) {
      // Every uploaded photo COVERS the print area. It used to arrive at 80% of the print WIDTH,
      // which on a mask covering only part of the artboard looked small and left customers unsure
      // where the printable area even was — they could not see the mask they were meant to fill.
      // Cover-fit makes the boundary self-evident: the photo meets the edges and any overhang
      // reads as bleed. This was already the behaviour for the FIRST photo on Custom Photo (the
      // full-bleed default that prevents FC363104-style gaps); it now applies to every upload on
      // every product. Objects stay freely movable and scalable, so a customer wanting a smaller
      // photo just drags a corner.
      var p = printRectPx();
      var sc = Math.max(p.width / img.width, p.height / img.height);
      img.set(Object.assign(centreish(), { scaleX: sc, scaleY: sc }));
      clipObj(img);
      fcanvas.add(img); fcanvas.setActiveObject(img); fcanvas.requestRenderAll(); snapshot();
      // The noun comes from the product. This hint fires for MODE 'overlay' AND 'flat' — the
      // latter being tote bags, mugs, posters, drinkware — so a hard-coded "case" was telling
      // a mug customer to fill a case.
      hint(MODE === 'print' ? 'Keep it inside the print area'
                            : 'Fill the ' + productNoun() + ' \u2014 a little overhang prints as bleed');
    }, { crossOrigin: 'anonymous' });
  }

  // A template slot is not a free object. Its bar would offer delete (on a REQUIRED slot),
  // duplicate (a second letter that belongs to no slot, so nothing tracks or exports it as one)
  // and bring-forward (which tplRestack immediately undoes). None of those are meaningful on a
  // locked layout — the slot is editable only in the ways the template says it is.
  // This only became reachable when a slot was first given move/scale/rotate.
  function tplOwned(o) { return !!(o && (o._pzTpl || o._pzSlot)); }
  // The case type is a variant option, so it can change while the editor is open.
  document.addEventListener('change', function () { try { syncDoneLabel(); } catch (e) {} });

  function updateObjBar() {
    var bar = modal.querySelector('[data-pz-objbar]');
    var o = fcanvas && fcanvas.getActiveObject();
    if (o && !o._pzGuide && !tplOwned(o)) bar.classList.add('show'); else bar.classList.remove('show');
  }

  /* ---------- events ---------- */
  function wireEvents() {
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-pz-close]')) return close();
      if (e.target.closest('[data-pz-intro-ok]')) { introShown = true; var iv = modal.querySelector('[data-pz-intro]'); if (iv) iv.hidden = true; return; }
      var tab = e.target.closest('[data-pz-tab]');
      if (tab) { switchTab(tab.dataset.pzTab); return; }
      if (e.target.closest('[data-pz-addtext]')) { var inp = modal.querySelector('[data-pz-text]'); addText(inp.value || 'Your text'); inp.value = ''; return; }
      var font = e.target.closest('[data-pz-fonts] .pz-font');
      if (font) { activeFont = font.dataset.font; modal.querySelectorAll('.pz-font').forEach(function (b) { b.classList.remove('is-active'); }); font.classList.add('is-active'); applyToActive('fontFamily', activeFont); return; }
      var sw = e.target.closest('.pz-sw');
      if (sw) { activeColour = sw.dataset.col; modal.querySelectorAll('.pz-sw').forEach(function (b) { b.classList.remove('is-active'); }); sw.classList.add('is-active'); applyToActive('fill', activeColour); return; }
      var st = e.target.closest('.pz-sticker');
      if (st) { addSticker(st.dataset.sticker); return; }
      if (e.target.closest('[data-pz-del]')) { var a = fcanvas.getActiveObject(); if (a && !tplOwned(a)) { fcanvas.remove(a); fcanvas.discardActiveObject(); fcanvas.requestRenderAll(); updateObjBar(); snapshot(); } return; }
      if (e.target.closest('[data-pz-dup]')) { var d = fcanvas.getActiveObject(); if (d && !tplOwned(d)) d.clone(function (c) { c.set({ left: d.left + 24, top: d.top + 24 }); fcanvas.add(c); fcanvas.setActiveObject(c); fcanvas.requestRenderAll(); snapshot(); }); return; }
      if (e.target.closest('[data-pz-forward]')) { var f = fcanvas.getActiveObject(); if (f && !tplOwned(f)) { fcanvas.bringForward(f); fcanvas.requestRenderAll(); snapshot(); } return; }
      if (e.target.closest('[data-pz-undo]')) { undo(); return; }
      if (e.target.closest('[data-pz-done]')) { finish(e.target.closest('[data-pz-done]')); return; }
    });

    modal.addEventListener('change', function (e) {
      var f = e.target.closest('[data-pz-file]');
      if (f && f.files && f.files[0]) {
        var file = f.files[0];
        if (file.size > 15 * 1024 * 1024) { hint('That image is over 15MB — try a smaller one'); f.value = ''; return; }
        // facescatter needs the RAW file (it uploads first — the cutout can only be derived
        // from a hosted asset), not a dataURL preview.
        if (fsIsScatter()) { fsProcessUpload(file); f.value = ''; return; }
        var rd = new FileReader();
        rd.onload = function (ev) {
          // A template product has a photo SLOT — the upload fills that, clipped to the window and
          // sitting under the frame. Without this the file would land as a free-floating image on
          // top of the design, which is exactly what the template exists to prevent.
          if (fsIsScatter()) { /* handled below with the raw file */ }
          else if (CFG.template && tplSlot('photo')) { tplSetPhoto(ev.target.result); hint('Drag or pinch to position your photo'); }
          else addImage(ev.target.result);
          f.value = '';
        };
        rd.readAsDataURL(file);
      }
    });

    // live-apply text input to a selected textbox
    var tinp = modal.querySelector('[data-pz-text]');
    tinp.addEventListener('input', function () {
      var a = fcanvas && fcanvas.getActiveObject();
      if (a && a.type === 'textbox') { a.set('text', tinp.value); fcanvas.requestRenderAll(); }
    });

    window.addEventListener('resize', function () { if (modal.classList.contains('is-open')) fitBoard(); });
  }

  // Build the customer-facing slot form. Driven entirely by the template's `slots`, so a future
  // template with different slots needs no code — which is the whole point of the format.
  function tplBuildPanel() {
    if (!CFG.template || !modal) return;
    var rail = modal.querySelector('.pz__panels') || (modal.querySelector('[data-pz-panel="photo"]') || {}).parentNode;
    if (!rail || rail.querySelector('[data-pz-panel="slots"]')) return;
    var slots = (CFG.template.slots || []).slice().sort(function (a, b) { return (a.order || 0) - (b.order || 0); });
    var html = '<div class="pz__panel is-active" data-pz-panel="slots"><div class="pz-slots">';
    slots.forEach(function (s) {
      html += '<div class="pz-slot" data-slot="' + s.id + '">';
      html += '<div class="pz-slot__label">' + s.label + (s.required ? ' <em>required</em>' : '') + '</div>';
      if (s.kind === 'photo') {
        html += '<label class="pz-slot__drop"><span data-slot-state>Choose a photo</span>' +
                '<input type="file" accept="image/*" data-pz-file></label>';
        if (s.help) html += '<p class="pz-slot__help">' + s.help + '</p>';
      } else if (s.kind === 'choice' && s.render === 'chips') {
        // Text chips (S / M / L and friends): reuse the font-chip look, no thumbnails.
        var ccur = tplChoice[s.id] || s.default;
        html += '<div class="pz-fonts" role="radiogroup" aria-label="' + s.label + '">';
        (s.options || []).forEach(function (o) {
          html += '<button type="button" class="pz-font' + (o.id === ccur ? ' is-on' : '') + '"' +
                  ' data-pz-choice="' + s.id + '" data-pz-opt="' + o.id + '" role="radio"' +
                  ' aria-checked="' + (o.id === ccur ? 'true' : 'false') + '">' + o.label + '</button>';
        });
        html += '</div>';
        if (s.help) html += '<p class="pz-slot__help">' + s.help + '</p>';
      } else if (s.kind === 'choice') {
        // Thumbnails, not names. The customer is picking artwork, and no wording distinguishes
        // fifteen stripe designs as fast as seeing them.
        var cur = tplChoice[s.id] || s.default;
        html += '<div class="pz-swatches" role="radiogroup" aria-label="' + s.label + '">';
        (s.options || []).forEach(function (o) {
          html += '<button type="button" class="pz-swatch' + (o.id === cur ? ' is-on' : '') + '"' +
                  ' data-pz-choice="' + s.id + '" data-pz-opt="' + o.id + '" role="radio"' +
                  ' aria-checked="' + (o.id === cur ? 'true' : 'false') + '" title="' + o.label + '">' +
                  '<img src="' + (o.thumb || o.src) + '" alt="' + o.label + '" loading="lazy">' +
                  '</button>';
        });
        html += '</div>';
        if (s.help) html += '<p class="pz-slot__help">' + s.help + '</p>';
      } else if (s.kind === 'gradient') {
        // Presets are pure CSS — a gradient needs no image, so the picker costs no bandwidth and
        // no Cloudinary assets, unlike every other background set in the range.
        var gcur = tplGradFrom, gcto = tplGradTo;
        html += '<div class="pz-swatches" role="radiogroup" aria-label="' + s.label + '">';
        (s.options || []).forEach(function (o) {
          var on = (o.from === gcur && o.to === gcto);
          html += '<button type="button" class="pz-swatch pz-swatch--grad' + (on ? ' is-on' : '') + '"' +
                  ' data-pz-grad="' + o.from + '|' + o.to + '" role="radio" aria-checked="' + (on ? 'true' : 'false') + '"' +
                  ' title="' + o.label + '" style="background:linear-gradient(' + o.from + ',' + o.to + ')"></button>';
        });
        html += '</div>';
        if (s.custom !== false) {
          html += '<div class="pz-grad2">' +
            '<label class="pz-grad2__c"><span>' + (s.fromLabel || 'Top colour') + '</span>' +
            '<input type="color" data-pz-grad-from value="' + (gcur || '#ffffff') + '"></label>' +
            '<label class="pz-grad2__c"><span>' + (s.toLabel || 'Bottom colour') + '</span>' +
            '<input type="color" data-pz-grad-to value="' + (gcto || '#000000') + '"></label>' +
            '</div>';
          html += '<p class="pz-slot__help">Tap a colour to pick any shade you like.</p>';
        }
      } else if (s.kind === 'text') {
        var single = (s.maxChars || 40) === 1;
        html += '<input class="pz-slot__text' + (single ? ' pz-slot__text--one' : '') + '" type="text" data-pz-slot-text="' + s.id + '" maxlength="' + (s.maxChars || 40) + '"' +
                (single ? ' autocapitalize="characters" spellcheck="false"' : '') +
                ' value="' + (s.default || '').replace(/"/g, '&quot;') + '">';
        html += '<p class="pz-slot__help">' + (single ? 'One letter' : 'Up to ' + (s.maxChars || 40) + ' characters') + (s.allowBlank ? ', or leave blank' : '') + '</p>';
        // Font, shown IN the font. A list of names tells the customer nothing; a list of specimens
        // is the choice itself.
        if ((s.fontOptions || []).length) {
          var cf = tplFont || s.defaultFont || s.font;
          html += '<div class="pz-slot__sub">' + (s.fontLabel || 'Font') + '</div><div class="pz-fonts" role="radiogroup">';
          s.fontOptions.forEach(function (f) {
            html += '<button type="button" class="pz-font' + (f.family === cf ? ' is-on' : '') + '"' +
                    ' data-pz-fontpick="' + f.family + '" role="radio" aria-checked="' + (f.family === cf ? 'true' : 'false') + '"' +
                    ' style="font-family:\'' + f.family + '\',cursive">' + (f.sample || 'Aa') + '</button>';
          });
          html += '</div>';
        }
        if ((s.fillOptions || []).length) {
          var cc = tplFill || s.defaultFill || s.fill;
          html += '<div class="pz-slot__sub">' + (s.fillLabel || 'Colour') + '</div><div class="pz-cols" role="radiogroup">';
          s.fillOptions.forEach(function (c) {
            html += '<button type="button" class="pz-col' + (c.hex === cc ? ' is-on' : '') + '"' +
                    ' data-pz-fill="' + c.hex + '" role="radio" aria-checked="' + (c.hex === cc ? 'true' : 'false') + '"' +
                    ' title="' + c.label + '" aria-label="' + c.label + '"><i style="background:' + c.hex + '"></i></button>';
          });
          html += '</div>';
        }
        // Outline. Two of these are not colours — 'Auto' follows the letter colour, 'None' removes
        // the outline — so they get their own swatch treatment rather than a coloured disc.
        if ((s.strokeOptions || []).length) {
          var cs = tplStrokeId || s.defaultStroke || s.strokeOptions[0].id;
          html += '<div class="pz-slot__sub">' + (s.strokeLabel || 'Outline') + '</div><div class="pz-cols" role="radiogroup">';
          s.strokeOptions.forEach(function (o) {
            var mod = o.auto ? ' pz-col--auto' : (o.hex ? '' : ' pz-col--none');
            html += '<button type="button" class="pz-col' + mod + (o.id === cs ? ' is-on' : '') + '"' +
                    ' data-pz-stroke="' + o.id + '" role="radio" aria-checked="' + (o.id === cs ? 'true' : 'false') + '"' +
                    ' title="' + o.label + '" aria-label="' + o.label + '"><i' + (o.hex ? ' style="background:' + o.hex + '"' : '') + '></i></button>';
          });
          html += '</div>';
        }
        if ((s.shadowOptions || []).length) {
          var csh = tplShadowId || s.defaultShadow || s.shadowOptions[0].id;
          html += '<div class="pz-slot__sub">' + (s.shadowLabel || 'Shadow') + '</div><div class="pz-cols" role="radiogroup">';
          s.shadowOptions.forEach(function (o) {
            var mod2 = o.auto ? ' pz-col--auto' : (o.hex ? '' : ' pz-col--none');
            html += '<button type="button" class="pz-col' + mod2 + (o.id === csh ? ' is-on' : '') + '"' +
                    ' data-pz-shadow="' + o.id + '" role="radio" aria-checked="' + (o.id === csh ? 'true' : 'false') + '"' +
                    ' title="' + o.label + '" aria-label="' + o.label + '"><i' + (o.hex ? ' style="background:' + o.hex + '"' : '') + '></i></button>';
          });
          html += '</div>';
        }
      }
      html += '</div>';
    });
    html += '</div></div>';
    rail.insertAdjacentHTML('beforeend', html);
    syncDoneLabel();
    // A pre-designed layout is not a canvas — hide the free tools so nothing can be dropped on it.
    modal.querySelectorAll('.pz-tab').forEach(function (t) { t.style.display = 'none'; });
    modal.querySelectorAll('.pz__panel').forEach(function (p) { if (p.dataset.pzPanel !== 'slots') p.classList.remove('is-active'); });
    modal.addEventListener('input', function (e) {
      var gf = e.target.closest('[data-pz-grad-from]'), gt = e.target.closest('[data-pz-grad-to]');
      if (gf || gt) {
        if (gf) tplGradFrom = gf.value; else tplGradTo = gt.value;
        // a hand-picked colour is no longer any preset
        modal.querySelectorAll('.pz-swatch--grad').forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-checked', 'false'); });
        tplSetBgChoice();
        return;
      }
      var ti = e.target.closest('[data-pz-slot-text]');
      if (!ti) return;
      var s = tplSlot(ti.getAttribute('data-pz-slot-text'));
      var v = ti.value;
      // A monogram is an initial. Coerce rather than validate: rejecting a lowercase key would just
      // look broken, and the design only ever reads as intended in caps.
      if (s && s.upper) { v = v.toUpperCase(); if (ti.value !== v) ti.value = v; }
      tplSetCaption(v);
    });
    // One delegated click for all three pickers. Each sets its own state and re-renders only what
    // changed — swapping the background must not throw away a name the customer has already typed.
    modal.addEventListener('click', function (e) {
      var mark = function (btn, sel) {
        var grp = btn.parentNode;
        grp.querySelectorAll(sel).forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-checked', 'false'); });
        btn.classList.add('is-on'); btn.setAttribute('aria-checked', 'true');
      };
      var sw = e.target.closest('[data-pz-choice]');
      if (sw) {
        e.preventDefault();
        var chId = sw.getAttribute('data-pz-choice');
        tplChoice[chId] = sw.getAttribute('data-pz-opt');
        mark(sw, sw.classList.contains('pz-swatch') ? '.pz-swatch' : '.pz-font');
        var chSlot = tplSlot(chId);
        if (chSlot && chSlot.render === 'chips') {
          if (fsIsScatter()) fsBuild();
        } else {
          tplSetBgChoice();
        }
        return;
      }
      var fb = e.target.closest('[data-pz-fontpick]');
      if (fb) {
        e.preventDefault();
        tplFont = fb.getAttribute('data-pz-fontpick');
        mark(fb, '.pz-font');
        // Rebuild rather than re-set: fabric measured the old face at construction.
        tplSetCaption(tplCaption);
        return;
      }
      var cb2 = e.target.closest('[data-pz-fill]');
      if (cb2) {
        e.preventDefault();
        tplFill = cb2.getAttribute('data-pz-fill');
        mark(cb2, '.pz-col');
        tplSetCaption(tplCaption);
        return;
      }
      var gb = e.target.closest('[data-pz-grad]');
      if (gb) {
        e.preventDefault();
        var parts = gb.getAttribute('data-pz-grad').split('|');
        tplGradFrom = parts[0]; tplGradTo = parts[1];
        mark(gb, '.pz-swatch');
        var fi = modal.querySelector('[data-pz-grad-from]'), ti2 = modal.querySelector('[data-pz-grad-to]');
        if (fi) fi.value = tplGradFrom; if (ti2) ti2.value = tplGradTo;
        tplSetBgChoice();
        return;
      }
      var sb = e.target.closest('[data-pz-stroke]');
      if (sb) {
        e.preventDefault();
        tplStrokeId = sb.getAttribute('data-pz-stroke');
        mark(sb, '.pz-col');
        tplSetCaption(tplCaption);
        return;
      }
      var shb = e.target.closest('[data-pz-shadow]');
      if (shb) {
        e.preventDefault();
        tplShadowId = shb.getAttribute('data-pz-shadow');
        mark(shb, '.pz-col');
        tplSetCaption(tplCaption);
      }
    });
  }

  function switchTab(name) {
    modal.querySelectorAll('.pz-tab').forEach(function (t) { t.classList.toggle('is-active', t.dataset.pzTab === name); });
    modal.querySelectorAll('.pz__panel').forEach(function (p) { p.classList.toggle('is-active', p.dataset.pzPanel === name); });
    if (fcanvas) fitBoard();
  }
  function applyToActive(prop, val) {
    var a = fcanvas && fcanvas.getActiveObject();
    if (!a || a._pzGuide) return;
    if (prop === 'fill' && a.type === 'image') return;
    a.set(prop, val); fcanvas.requestRenderAll(); snapshot();
  }

  /* ---------- export + cart hand-off ---------- */
  // Print-file resolution. A phone case print area is small, so a flat 2000px clears 300dpi
  // easily; a 335mm garment panel at 2000px is 152dpi and prints soft. When the mask knows its
  // physical size, derive the width from that instead.
  //
  // The clamps are not cosmetic. Mobile Safari silently returns a BLANK canvas — no exception —
  // once the total pixel count or a single side goes over budget, which would ship empty print
  // files that nothing downstream would flag. Staying inside both limits is the only reliable
  // guard. 4096 is the conservative single-side ceiling (older iOS); the area budget sits well
  // under Safari's ~16.7MP total.
  var EXPORT_DPI = 300;
  var EXPORT_MAX_SIDE = 4096;
  var EXPORT_MAX_PX = 13.5e6;
  function exportMultiplier(z) {
    var mk = CFG.flatMask, mm = mk && mk.printMm;
    // No physical size on the mask (phones, placed mockups) → exactly today's behaviour.
    if (!mm || !mm[0] || !mm[1]) return (CFG.exportWidth || 2000) / (AW * z);
    var p = printRectPx();
    var ratio = p.height / p.width;
    // The export covers the artboard, which for a bleed mask is the panel PLUS bleed on both edges.
    var w = (mm[0] + (mk.bleedMm || 0) * 2) / 25.4 * EXPORT_DPI;
    if (w > EXPORT_MAX_SIDE) w = EXPORT_MAX_SIDE;
    if (w * ratio > EXPORT_MAX_SIDE) w = EXPORT_MAX_SIDE / ratio;
    if (w * w * ratio > EXPORT_MAX_PX) w = Math.sqrt(EXPORT_MAX_PX / ratio);
    // Never export lower than the flat-2000px path would have.
    var legacy = (CFG.exportWidth || 2000) * p.width / AW;
    return Math.max(w, legacy) / (p.width * z);
  }
  function exportArt(keepBackground) {
    // The print file is the artwork only — drop the mockup/garment + guides.
    // keepBackground: on the legacy phone pipeline the stock DESIGN is the canvas background, not
    // a mockup, so it must stay in the file (see finishDyoPrintify).
    fcanvas.discardActiveObject();
    // Blank the white canvas fill too: uncovered print-rect areas must export TRANSPARENT
    // (unprinted), not baked white — white padding printed as a white block on clear/black
    // cases and made the artwork read smaller than the case (FC363104).
    var savedOverlay = fcanvas.overlayImage, savedBg = fcanvas.backgroundImage, savedBc = fcanvas.backgroundColor, savedClip = fcanvas.clipPath;
    fcanvas.overlayImage = null; fcanvas.backgroundImage = keepBackground ? savedBg : null; fcanvas.backgroundColor = ''; fcanvas.clipPath = null;
    fcanvas.getObjects().forEach(function (o) { if (o._pzGuide) o.visible = false; });
    var z = fcanvas.getZoom();
    var opts = { format: 'png', multiplier: exportMultiplier(z) };
    if (PRINT) {
      // Crop to the print area (garment print box, or a small overlay window like the FunGrip grip).
      // Board -> canvas coordinates is (board * zoom + viewport offset). The offset used to be 0
      // for everything except VIEWCROP, so it was safe to omit — and omitting it is exactly why
      // VIEWCROP was said to "break the print file". BOARD_PAD makes the offset non-zero always,
      // so read it from the viewport rather than assuming.
      var p = printRectPx(), vpt = fcanvas.viewportTransform;
      opts.left = p.left * z + vpt[4]; opts.top = p.top * z + vpt[5];
      opts.width = p.width * z; opts.height = p.height * z;
    }
    // Silhouette-clipped photos (custom phone) bleed to the FULL print rect in the export —
    // the tight rounded clip is editor cosmetics only.
    var bleedSwapped = [];
    if (PRINT) {
      var pb = printRectPx();
      fcanvas.getObjects().forEach(function (o) {
        if (o._pzPrintBleed && o.clipPath) {
          bleedSwapped.push({ o: o, clip: o.clipPath });
          o.clipPath = new fabric.Rect({ left: pb.left, top: pb.top, width: pb.width, height: pb.height, absolutePositioned: true });
        }
      });
    }
    var data = fcanvas.toDataURL(opts);
    bleedSwapped.forEach(function (s) { s.o.clipPath = s.clip; });
    fcanvas.overlayImage = savedOverlay; fcanvas.backgroundImage = savedBg; fcanvas.backgroundColor = savedBc; fcanvas.clipPath = savedClip;
    fcanvas.getObjects().forEach(function (o) { if (o._pzGuide) o.visible = true; });
    fcanvas.requestRenderAll();
    return data;
  }
  // The print PREVIEW keeps the mockup/garment so the team can see WHERE the design sits.
  function exportPreview() {
    fcanvas.discardActiveObject();
    // Capture on a TRANSPARENT canvas: where the mockup/design don't cover the board (edges,
    // print window) we want transparency, not the canvas's white fill — otherwise a white
    // border bakes into the preview and shows against the (cream) gallery frame.
    var bc = fcanvas.backgroundColor;
    fcanvas.backgroundColor = '';
    fcanvas.getObjects().forEach(function (o) { if (o._pzGuide) o.visible = false; });
    var z = fcanvas.getZoom();
    // Crop away BOARD_PAD so the preview frames exactly the board (or the VIEWCROP region), which
    // is what the canvas element used to be before the margin existed. Without this the preview
    // gains a transparent border and the design renders smaller than previewWidth implies.
    // The board's region in CANVAS coordinates, derived from the live viewport rather than assumed
    // — fitView can leave the canvas at a different zoom/offset than fitBoard would.
    var vpt = fcanvas.viewportTransform;
    var vw = VIEWCROP ? VIEWCROP.width : AW, vh = VIEWCROP ? VIEWCROP.height : AH;
    var vx = VIEWCROP ? VIEWCROP.left : 0, vy = VIEWCROP ? VIEWCROP.top : 0;
    var data = fcanvas.toDataURL({
      format: 'png', multiplier: (CFG.previewWidth || 1200) / (AW * z),
      left: vx * z + vpt[4], top: vy * z + vpt[5],
      width: vw * z, height: vh * z,
    });
    fcanvas.backgroundColor = bc;
    fcanvas.getObjects().forEach(function (o) { if (o._pzGuide) o.visible = true; });
    fcanvas.requestRenderAll();
    return data;
  }
  function dataURLtoFile(dataurl, name) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8 = new Uint8Array(n);
    while (n--) u8[n] = bstr.charCodeAt(n);
    return new File([u8], name, { type: mime });
  }
  // Attach a data-URL image as a native file line-item property (Shopify uploads it, URL lands on the order).
  function attachFile(form, propName, dataUrl, filename, marker) {
    var input = form.querySelector('input[data-pz-file-marker="' + marker + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'file'; input.name = 'properties[' + propName + ']';
      input.setAttribute('data-pz-file-marker', marker); input.hidden = true;
      form.appendChild(input);
    }
    try {
      var dt = new DataTransfer();
      dt.items.add(dataURLtoFile(dataUrl, filename));
      input.files = dt.files;
      return true;
    } catch (err) { return false; }
  }
  // Swap the PDP main image to the personalised preview so the product shows their design.
  var pdpOriginalSrc = null, pdpOriginalSrcset = null;
  function showOnPdp(src) {
    if (!src) return;
    var img = document.querySelector('[data-pdp-image]');
    if (!img) return;
    if (pdpOriginalSrc === null) { pdpOriginalSrc = img.src; pdpOriginalSrcset = img.getAttribute('srcset'); }
    img.removeAttribute('srcset'); img.src = src;
    // Personalised previews come in the product's OWN aspect (a portrait poster, a tall case…),
    // so let the square gallery frame adapt to the image instead of letterboxing it (no border).
    var frame = img.closest('.pdp-gallery__frame'); if (frame) frame.classList.add('pz-custom');
  }
  // DYO Tough/MagSafe Tough: the DYO gallery is single-image (no thumbs/arrows), so build a
  // self-contained carousel of the Printify mockups — arrows in the frame + a thumbnail strip —
  // reusing the theme's .pdp-gallery__nav / .pdp-thumb styles. Cleaned up on remove.
  var ARROW_SVG = { prev: '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>', next: '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>' };
  function clearMockupGallery() { document.querySelectorAll('[data-pz-gallery]').forEach(function (el) { el.remove(); }); }
  function showMockupGallery(mockups) {
    mockups = (mockups || []).filter(Boolean);
    if (!mockups.length) return;
    var img = document.querySelector('[data-pdp-image]');
    if (!img) return;
    var frame = img.closest('.pdp-gallery__frame');
    var gallery = img.closest('.pdp-gallery');
    if (pdpOriginalSrc === null) { pdpOriginalSrc = img.src; pdpOriginalSrcset = img.getAttribute('srcset'); }
    clearMockupGallery();
    var idx = 0, strip = null;
    function render() {
      img.removeAttribute('srcset'); img.src = mockups[idx];
      if (frame) frame.classList.add('pz-custom');
      if (strip) [].forEach.call(strip.children, function (b, i) { b.classList.toggle('is-active', i === idx); });
    }
    if (mockups.length > 1 && frame) {
      ['prev', 'next'].forEach(function (dir) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'pdp-gallery__nav pdp-gallery__nav--' + dir;
        b.setAttribute('data-pz-gallery', 'nav'); b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
        b.innerHTML = ARROW_SVG[dir];
        b.addEventListener('click', function () { idx = dir === 'prev' ? (idx - 1 + mockups.length) % mockups.length : (idx + 1) % mockups.length; render(); });
        frame.appendChild(b);
      });
      if (gallery) {
        strip = document.createElement('div'); strip.className = 'pdp-thumbs'; strip.setAttribute('data-pz-gallery', 'thumbs');
        mockups.forEach(function (u, i) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'pdp-thumb' + (i === 0 ? ' is-active' : ''); b.setAttribute('aria-label', 'View mockup ' + (i + 1));
          b.innerHTML = '<img src="' + u + '" alt="Your case mockup ' + (i + 1) + '" loading="lazy" width="90" height="90">';
          b.addEventListener('click', function () { idx = i; render(); });
          strip.appendChild(b);
        });
        gallery.appendChild(strip);
      }
    }
    render();
  }
  // Mask-driven flat products have no mockup to render the design into — and the GoBear
  // plates never will — so the gallery keeps the real product photo and gets a badge instead
  // of the bare artwork, which reads as "we printed a flat picture on it".
  // Set as soon as any mask drives the canvas, so the save step knows the export is a print
  // plate rather than a picture of the product — true for phone plates and product plates alike.
  var pzSafeHinted = false;   // the fold/safe-area hint fires once per session, not per redraw
  var pzUsedMask = false;
  // A tick in a circle reads as "done" but says nothing about the photo. Customers took the
  // unchanged image to mean their design had been lost, so state it outright AND show a
  // thumbnail of what they actually made — the proof sits next to the claim.
  function pzBadgeOn(previewSrc) {
    var img = document.querySelector('[data-pdp-image]');
    var frame = img && img.closest('.pdp-gallery__frame');
    if (!frame || frame.querySelector('[data-pz-badge]')) return;
    var b = document.createElement('div');
    b.className = 'pz-note';
    b.setAttribute('data-pz-badge', '');
    b.innerHTML =
      (previewSrc ? '<img class="pz-note__thumb" src="' + previewSrc + '" alt="Your design">' : '') +
      '<span class="pz-note__txt"><strong>Your design is saved</strong>' +
      'This photo stays as the plain product. It won\u2019t update, but we print exactly what you made.</span>';
    frame.appendChild(b);
  }
  function pzBadgeOff() {
    document.querySelectorAll('[data-pz-badge]').forEach(function (el) { el.remove(); });
  }
  function restorePdp() {
    clearMockupGallery();
    pzBadgeOff();                 // before the early return — the badge exists even when nothing was swapped
    if (pdpOriginalSrc === null) return;
    var img = document.querySelector('[data-pdp-image]');
    if (img) {
      img.src = pdpOriginalSrc; if (pdpOriginalSrcset) img.setAttribute('srcset', pdpOriginalSrcset);
      var frame = img.closest('.pdp-gallery__frame'); if (frame) frame.classList.remove('pz-custom');
    }
    pdpOriginalSrc = null; pdpOriginalSrcset = null;
  }
  // Notify the PDP (e.g. to gate Add to Bag on Design-Your-Own) when a design is attached/removed.
  function emitChange() { try { document.dispatchEvent(new CustomEvent('pz:designchange', { detail: { hasDesign: designAttached } })); } catch (e) {} }
  // Common: hide the trigger, show the ready card, store the flag + property URLs.
  function markReady(form, previewSrc, previewUrl, printUrl, noSwap, realMockup) {
    if (PZ_EDIT) { adminAttach(previewUrl, printUrl); }
    if (form) {
      // Underscore-prefixed → stored on the line but hidden from the customer everywhere
      // (cart, checkout, order confirmation + emails). Fulfilment still reads them server-side.
      setHidden(form, '_Your design', previewUrl);
      setHidden(form, '_Print file', printUrl);
      setHidden(form, '_Personalised', 'Yes');
      // A mask export is a print plate, not a picture of the product. Flag the line so the
      // cart shows the product photo rather than the plate (the PDP does the same).
      if (pzUsedMask || (CFG.flatMask && CFG.flatMask.mask)) setHidden(form, '_Flat plate', 'Yes');
      // Record what the customer PICKED, not just the flattened artwork. The print file is the
      // source of truth for production, but a leading underscore hides a property from the
      // customer — and these three are the whole product from their side, so they are named
      // plainly and shown on the order. It also makes a support query answerable without
      // opening the print file.
      if (CFG.template) {
        tplChoiceSlots().forEach(function (s) {
          var o = tplOption(s, tplChoice[s.id] || s.default);
          if (o) setHidden(form, s.label || s.id, o.label || o.id);
        });
        var gsl = (CFG.template.slots || []).filter(function (x) { return x.kind === 'gradient'; })[0];
        if (gsl) {
          var pre = (gsl.options || []).filter(function (o) { return o.from === tplGradFrom && o.to === tplGradTo; })[0];
          setHidden(form, gsl.label || 'Background', pre ? pre.label : tplGradFrom + ' to ' + tplGradTo);
        }
        var ts = tplTextSlot();
        if (ts && (ts.fontOptions || []).length) {
          var f = ts.fontOptions.filter(function (x) { return x.family === (tplFont || ts.defaultFont || ts.font); })[0];
          if (f) setHidden(form, ts.fontLabel || 'Font', f.label || f.family);
        }
        if (ts && (ts.fillOptions || []).length) {
          var c = ts.fillOptions.filter(function (x) { return x.hex === (tplFill || ts.defaultFill || ts.fill); })[0];
          if (c) setHidden(form, ts.fillLabel || 'Colour', c.label);
        }
        if (ts && (ts.strokeOptions || []).length) {
          var sid = tplStrokeId || ts.defaultStroke || ts.strokeOptions[0].id;
          var so = ts.strokeOptions.filter(function (x) { return x.id === sid; })[0];
          if (so) setHidden(form, ts.strokeLabel || 'Outline', so.label);
        }
        if (ts && (ts.shadowOptions || []).length) {
          var shid = tplShadowId || ts.defaultShadow || ts.shadowOptions[0].id;
          var sho = ts.shadowOptions.filter(function (x) { return x.id === shid; })[0];
          if (sho) setHidden(form, ts.shadowLabel || 'Shadow', sho.label);
        }
      }
    }
    designAttached = true;
    // The floating bar is the safety net for every path; on an outsourced case it is the ONLY
    // prompt, because that path deliberately reveals the Printify mockup instead of adding to bag.
    try { pzEnsureBar(previewSrc); } catch (e) {}
    if (!PZ_EDIT && !(selectedCaseTypeOutsourced() || isOutsourcedApparel())) {
      // Let the finish path close the modal first — clicking Add to bag under an open overlay
      // would put the theme's cart drawer behind it.
      setTimeout(function () { try { pzAddToBag(); } catch (e) {} }, 350);
    }
    var trigger = document.querySelector('.pz-open[data-pz-open]');
    if (trigger) trigger.hidden = true;
    var thumb = document.querySelector('[data-pz-preview]');
    if (thumb) {
      thumb.innerHTML = '<img src="' + previewSrc + '" alt="Your design">' +
        '<span class="pz-preview__msg">Your design is ready 🎉</span>' +
        '<button type="button" class="pz-preview__edit" data-pz-open>Edit</button>' +
        '<button type="button" class="pz-preview__remove" data-pz-remove aria-label="Remove design">Remove</button>';
      thumb.hidden = false;
    }
    // Phones already skip the swap (their tall export blows up the frame). Mask-driven flat
    // products skip it too, for a different reason: the export is the print plate, not a
    // picture of the product. Both keep the product photo, so both get the badge.
    var pzMaskFlat = pzUsedMask || !!(CFG.flatMask && CFG.flatMask.mask);
    // realMockup: a Printify mockup of the customer's own artwork is coming, so the badge
    // explaining that the photo WON'T update would contradict the gallery beside it.
    if (noSwap || pzMaskFlat) { if (pzMaskFlat && !realMockup) pzBadgeOn(previewSrc); }
    else showOnPdp(previewUrl || previewSrc);
    emitChange();
  }
  // Design-Your-Own on an outsourced case type (Tough / MagSafe Tough): the artwork goes to
  // Printify/WOYC, so we upload the print file, ask the bridge to build a Printify product +
  // generate the on-case mockup, show that mockup, and stash the Printify reference on the line
  // so the order auto-produces. No team review.
  var DYO_PREVIEW_ENDPOINT = 'https://fun-cases-hub.vercel.app/api/router/dyo/preview';
  function finishDyoPrintify(btn) {
    if (btn) btn.classList.add('is-busy');
    // A stock design personalised on Tough / MagSafe Tough normally opens on the model's Printify
    // plate, where the design is a locked _pzBase object and exports with the additions. A model with
    // no plate yet falls back to the legacy phone pipeline, where the design is the canvas BACKGROUND
    // instead — and exportArt strips backgrounds, so the file held only the customer's additions.
    // Printify printed exactly that: a white case with a sticker or initials on it (FC371949).
    // Keep the background whenever it is the stock artwork, so no plate gap can blank a case again.
    var designInBackground = !!(CFG.baseDesignRaw && PIPE === 'phone' && fcanvas.backgroundImage &&
      !fcanvas.getObjects().some(function (o) { return o._pzBase; }));
    var printData = exportArt(designInBackground);   // the customer's artwork, print-ready
    // Read the garment spec ONCE: the body, the copy and the camera choice must all agree, and
    // re-reading the PDP three times invites them to drift apart.
    var apparel = isOutsourcedApparel() ? teeSpec() : null;
    loading(true, apparel ? 'Creating your preview…' : 'Creating your case preview…');
    var done = function () { if (btn) btn.classList.remove('is-busy'); loading(false); };
    var blob;
    try { blob = dataURLtoBlob(printData); } catch (e) { blob = null; }
    if (!blob) { alert('Could not save your design. Please try again.'); done(); return; }
    uploadAdditions(blob).then(function (printId) {
      var printUrl = 'https://res.cloudinary.com/' + CFG.cloudName + '/image/upload/' + printId;
      return fetch(DYO_PREVIEW_ENDPOINT, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({ designUrl: printUrl },
          apparel || { model: CFG.model, caseType: selectedCaseType() })),
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j, printUrl: printUrl }; }); });
    }).then(function (res) {
      if (!res.ok || !res.j || res.j.error) throw new Error((res.j && res.j.error) || 'preview failed');
      var form = document.querySelector(CFG.productFormSelector || '[data-pdp-form]');
      var allMockups = (res.j.mockups && res.j.mockups.length) ? res.j.mockups : [res.j.mockup].filter(Boolean);
      if (apparel) allMockups = orderTeeMockups(allMockups, apparel.productType, apparel.position);
      var mockup = allMockups[0] || res.printUrl;
      // noSwap:true — the gallery (below) owns the PDP images, not markReady's single swap.
      markReady(form, mockup, mockup, res.printUrl, true, true);
      showMockupGallery(allMockups);
      if (form) {
        setHidden(form, '_PrintifyProduct', res.j.productId);
        setHidden(form, '_PrintifyVariant', String(res.j.variantId));
      }
      done(); close();
      // Mobile: the editor closes back to wherever the Personalise button was (far down the page),
      // so the customer can't see the mockups just generated — scroll them up to the gallery.
      if (window.innerWidth < 900) {
        var g = document.querySelector('.pdp-gallery');
        if (g) setTimeout(function () { g.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 150);
      }
    }).catch(function (e) {
      // Keep the technical detail in the console for us; show the customer something they can act
      // on. The raw string here is a Printify API error including status codes, endpoint paths and
      // a support reference — dumping that into an alert on a consumer storefront is noise at best
      // and leaks internals at worst.
      if (window.console && console.error) console.error('[personaliser] preview failed:', e);
      alert('Sorry — we could not build your preview just then. Please tap Done again.');
      done();
    });
  }
  // An outsourced case is produced by Printify whoever designed it, so the artwork must go through
  // the Printify preview flow on a STOCK design exactly as it does on Design-Your-Own. Requiring
  // CFG.isCustom here would have quietly saved a Tough design down the in-house path.
  function selectedCaseTypeOutsourced() { return isOutsourcedCase(); }
  // ── Design state (admin editing) ──────────────────────────────────────────────
  // At save, the full layered editor state uploads as raw JSON; the _Design state
  // property is a click-to-edit ADMIN LINK that reopens this exact design (?pzedit=).
  var PZ_EDIT = (location.search.match(/[?&]pzedit=([^&]+)/) || [])[1] || null;
  function uploadState() {
    try {
      var json = JSON.stringify(fcanvas.toDatalessJSON(['_pzBase', '_pzGuide', '_pzPlate', '_pzPrintBleed', '_pzTpl', '_pzSlot']));
      var fd = new FormData();
      fd.append('file', new Blob([json], { type: 'application/json' }), 'state.json');
      fd.append('upload_preset', CFG.uploadPreset);
      return fetch('https://api.cloudinary.com/v1_1/' + CFG.cloudName + '/raw/upload', { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d.public_id) return null;
          var vid = document.querySelector('[data-pdp-variant-id]');
          return location.origin + location.pathname + '?variant=' + (vid ? vid.value : '') + '&pzedit=' + encodeURIComponent(d.public_id);
        }).catch(function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  }
  // What the customer actually added: photos, text, stickers, template slots. Guides, plates, the
  // base artwork and template backgrounds are ours, and an untouched "Your text" box is not an edit.
  function userAdditions() {
    return fcanvas.getObjects().filter(function (o) {
      if (o._pzGuide || o._pzPlate || o._pzBase || o._pzPrintGuide || o._pzPrintBleed || o._pzGuideRect || o._pzTpl) return false;
      if (o.type === 'textbox') { var t = (o.text || '').trim().toLowerCase(); if (!t || t === 'your text') return false; }
      return true;
    }).length;
  }
  // Saving with nothing added used to put "_Personalised: Yes" and a print file on a line that was
  // just the stock design, so the cart, emails and print queue all called it personalised. Ask first.
  // DYO / Custom Photo have no design of their own, so a blank one is never added from here.
  function confirmEmpty(btn) {
    var custom = !!CFG.isCustom;
    var ov = document.createElement('div');
    ov.className = 'pz-confirm';
    ov.innerHTML = '<div class="pz-confirm__card">' +
      '<div class="pz-confirm__ico">✏️</div>' +
      '<h3>You haven\'t added anything yet</h3>' +
      (custom
        ? '<p>Add a photo, some text or a sticker to your design before you save it.</p>'
        : '<p>Add a photo, some text or a sticker to personalise it. Or add the standard design to your bag without personalising.</p>') +
      '<div class="pz-confirm__btns">' +
        '<button type="button" class="pz-confirm__keep" data-pz-keep>Keep designing</button>' +
        (custom ? '' : '<button type="button" class="pz-confirm__go" data-pz-plain>Add without personalising</button>') +
      '</div></div>';
    document.body.appendChild(ov);
    ov.addEventListener('click', function (e) {
      if (e.target.closest('[data-pz-plain]')) {
        ov.remove(); clearDesign(); close();
        if (btn) btn.classList.remove('is-busy');
        pzAddToBag();
        return;
      }
      if (e.target.closest('[data-pz-keep]') || e.target === ov) { ov.remove(); return; }
    });
  }
  function finish(btn) {
    // Template products (monogram, faces...) are personalised by their choices, not by added objects.
    if (!CFG.template && userAdditions() === 0) { confirmEmpty(btn); return; }
    // Kick the state upload off in parallel with the save pipeline; attach when ready.
    uploadState().then(function (editUrl) {
      if (!editUrl) return;
      var form = document.querySelector(CFG.productFormSelector || '[data-pdp-form]');
      if (form) setHidden(form, '_Design state', editUrl);
    });
    // Drop any text box still reading the untouched "Your text" placeholder — the
    // customer never edited it, and one printed over the artwork on FC363049.
    fcanvas.getObjects().filter(function (o) { return o.type === 'textbox' && (o.text || '').trim().toLowerCase() === 'your text'; })
      .forEach(function (o) { fcanvas.remove(o); });

    // DYO Tough/MagSafe Tough → Printify preview flow (create product + mockup, no team review).
    if (selectedCaseTypeOutsourced() || isOutsourcedApparel()) { finishDyoPrintify(btn); return; }
    // Route by the ACTIVE pipeline, not by isPhone: a phone-type product can still be a 'placed'
    // mockup (e.g. the Wallet Phone Case), which must finish through finishPlaced so its mockup PNG
    // is composited — otherwise it falls back to the raw print with no mockup.
    if (PIPE === 'flat') { finishFlat(btn); return; }
    if (PIPE === 'phone') { finishPhone(btn); return; }
    finishPlaced(btn);
  }
  // Placed (overlay) products: upload the print artwork + the in-context preview so both land on
  // the cart as clean Cloudinary URLs (like phones/flat), instead of base64 file properties.
  function finishPlaced(btn) {
    if (btn) btn.classList.add('is-busy');
    var previewData = exportPreview();   // full editor (design + additions + mockup)
    var printData = exportArt();         // design + additions cropped to the print area
    loading(true, 'Saving your design…');
    var done = function () { if (btn) btn.classList.remove('is-busy'); loading(false); };
    var pblob, rblob;
    try { pblob = dataURLtoBlob(previewData); rblob = dataURLtoBlob(printData); } catch (e) { pblob = null; }
    if (!pblob || !rblob) { alert('Could not save your design. Please try again.'); done(); return; }
    Promise.all([uploadAdditions(rblob), uploadAdditions(pblob)]).then(function (ids) {
      var CL = 'https://res.cloudinary.com/' + CFG.cloudName + '/';
      // Phones skip the PDP main-image swap (their tall canvas export would blow up the gallery
      // frame into a giant vertical image) — the design is confirmed via the ready card, exactly
      // like the stock personalised phone cases. Garments/posters still swap so their design shows.
      markReady(document.querySelector(CFG.productFormSelector || '[data-pdp-form]'), previewData, CL + 'image/upload/' + ids[1], CL + 'image/upload/' + ids[0], CFG.isPhone);
      done(); close();
    }).catch(function () { alert('Could not save your design — please check your connection and try again.'); done(); });
  }
  // Phone pipeline: capture the additions → upload to Cloudinary → store the composited URLs.
  function finishPhone(btn) {
    if (btn) btn.classList.add('is-busy');
    var localPreview = exportPreview();   // instant thumbnail for the ready card
    var blob;
    try { blob = captureAdditions(); } catch (e) { blob = null; }
    loading(true, 'Saving your design…');
    var done = function () { if (btn) btn.classList.remove('is-busy'); loading(false); };
    if (!blob) { alert('Could not save your design. Please try again.'); done(); return; }
    uploadAdditions(blob).then(function (publicId) {
      var urls = buildPhoneUrls(publicId);
      markReady(document.querySelector(CFG.productFormSelector || '[data-pdp-form]'), localPreview, urls.preview, urls.print, true);
      done(); close();
    }).catch(function () {
      alert('Could not save your design — please check your connection and try again.');
      done();
    });
  }
  // Flat pipeline (clothing/drinkware): capture the whole artboard as ONE artwork → upload →
  // composite onto the garment/drinkware via the product recipe (l_<artwork> in the c_fit box).
  function finishFlat(btn) {
    if (btn) btn.classList.add('is-busy');
    var localPreview = exportPreview();
    var blob;
    try { blob = captureArtboard(); } catch (e) { blob = null; }
    loading(true, 'Saving your design…');
    var done = function () { if (btn) btn.classList.remove('is-busy'); loading(false); };
    if (!blob) { alert('Could not save your design. Please try again.'); done(); return; }
    uploadAdditions(blob).then(function (publicId) {
      var CL = 'https://res.cloudinary.com/' + CFG.cloudName + '/';
      var previewUrl = flatEntry && flatEntry.preview
        ? CL + 'image/upload/' + flatEntry.preview.replace('{ARTWORK}', publicId)
        : CL + 'image/upload/' + publicId;
      var printUrl = CL + 'image/upload/' + publicId;   // the flat artwork IS the print file
      markReady(document.querySelector(CFG.productFormSelector || '[data-pdp-form]'), localPreview, previewUrl, printUrl);
      done(); close();
    }).catch(function () {
      alert('Could not save your design — please check your connection and try again.');
      done();
    });
  }
  // Wipe an unsaved design (used when the shopper changes variant before adding to bag).
  function clearDesign() {
    designAttached = false;
    try { pzBarSync(); } catch (e) {}
    var form = document.querySelector(CFG.productFormSelector || '[data-pdp-form]');
    if (form) {
      ['preview', 'print'].forEach(function (mk) { var i = form.querySelector('input[data-pz-file-marker="' + mk + '"]'); if (i) i.remove(); });
      var names = ['_Your design', 'Your design', '_Print file', '_Personalised', '_Flat plate', 'Print file (test)',
                 // The DYO trio. These outlived clearDesign() and reached the order without
                 // _Personalised or _Print file beside them. _PrintifyProduct is the DYO marker the
                 // hub's router keys on, so a stale one made it order the Printify product built
                 // from a design the customer had already deleted (seen on FC368579, line 2).
                 // A server-side guard now requires _Print file or _Personalised alongside it, but
                 // these must stop being written onto orders at source too.
                 '_Design state', '_PrintifyProduct', '_PrintifyVariant'];
      // The template's own choice properties go too. Leaving "Background: Pink & Green" on a line
      // whose artwork has just been wiped would describe a design that no longer exists.
      if (CFG.template) {
        tplChoiceSlots().forEach(function (s) { names.push(s.label || s.id); });
        (CFG.template.slots || []).filter(function (x) { return x.kind === 'gradient'; }).forEach(function (x) { names.push(x.label || 'Background'); });
        var ts2 = tplTextSlot();
        if (ts2) { names.push(ts2.fontLabel || 'Font'); names.push(ts2.fillLabel || 'Colour'); names.push(ts2.strokeLabel || 'Outline'); names.push(ts2.shadowLabel || 'Shadow'); }
      }
      names.forEach(function (n) {
        var el = form.querySelector('input[name="properties[' + n + ']"]'); if (el) el.remove();
      });
    }
    var thumb = document.querySelector('[data-pz-preview]');
    if (thumb) { thumb.hidden = true; thumb.innerHTML = ''; }
    var trigger = document.querySelector('.pz-open[data-pz-open]');
    if (trigger) trigger.hidden = false;
    restorePdp();   // put the normal product image back
    // Reset the canvas so the next open starts fresh for the new variant.
    if (fcanvas) {
      fcanvas.getObjects().slice().forEach(function (o) { if (!o._pzGuide) fcanvas.remove(o); });
      baseLoaded = false; history = []; histIdx = -1; fcanvas.requestRenderAll();
    }
    emitChange();
  }
  // Themed "you'll lose your design" confirm. onProceed() runs only if the shopper agrees.
  function confirmReset(onProceed) {
    var ov = document.createElement('div');
    ov.className = 'pz-confirm';
    ov.innerHTML = '<div class="pz-confirm__card">' +
      '<div class="pz-confirm__ico">⚠️</div>' +
      '<h3>Change without saving?</h3>' +
      '<p>You\'ve personalised this item but haven\'t added it to your bag yet. Changing your phone or options now will <b>clear your design</b>.</p>' +
      '<div class="pz-confirm__btns">' +
        '<button type="button" class="pz-confirm__keep" data-pz-keep>Keep my design</button>' +
        '<button type="button" class="pz-confirm__go" data-pz-go>Discard &amp; change</button>' +
      '</div></div>';
    document.body.appendChild(ov);
    ov.addEventListener('click', function (e) {
      if (e.target.closest('[data-pz-go]')) { ov.remove(); clearDesign(); if (onProceed) onProceed(); return; }
      if (e.target.closest('[data-pz-keep]') || e.target === ov) { ov.remove(); return; }
    });
  }
  function setHidden(form, name, val) {
    var sel = 'input[name="properties[' + name + ']"]';
    var el = form.querySelector(sel);
    if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = 'properties[' + name + ']'; form.appendChild(el); }
    el.value = val;
  }

  /* ---------- admin edit mode (?pzedit=) ---------- */
  function adminAttach(previewUrl, printUrl) {
    // A panel, not window.prompt(). Chrome attaches "prevent this page from
    // creating additional dialogs" to the SECOND dialog a page opens, which is
    // exactly the password one — it returned null and the attach died silently.
    if (document.querySelector('[data-pzfix]')) return;
    var wrap = document.createElement('div');
    wrap.setAttribute('data-pzfix', '');
    wrap.style.cssText = 'position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;padding:16px';
    wrap.innerHTML =
      '<div style="background:#fff;border:2px solid #161616;border-radius:20px;padding:18px;max-width:400px;width:100%;box-shadow:4px 4px 0 #161616">' +
      '<p style="margin:0 0 10px;font-weight:800;font-size:16px">Attach this fix to an order</p>' +
      '<input data-pzfix-order placeholder="FC368092" autocomplete="off" style="width:100%;box-sizing:border-box;padding:9px 10px;border:2px solid #ddd;border-radius:12px;font-weight:700;margin-bottom:8px">' +
      '<input data-pzfix-key type="password" placeholder="Bridge admin password" style="width:100%;box-sizing:border-box;padding:9px 10px;border:2px solid #ddd;border-radius:12px;font-weight:700;margin-bottom:8px">' +
      '<p data-pzfix-msg style="margin:0 0 10px;font-size:12px;font-weight:700;color:#666;min-height:16px"></p>' +
      '<div style="display:flex;gap:8px;justify-content:flex-end">' +
      '<button type="button" data-pzfix-cancel style="border:2px solid #161616;background:#fff;border-radius:999px;padding:7px 14px;font-weight:800;cursor:pointer">Cancel</button>' +
      '<button type="button" data-pzfix-go style="border:2px solid #161616;background:#161616;color:#fff;border-radius:999px;padding:7px 16px;font-weight:800;cursor:pointer">Attach</button>' +
      '</div></div>';
    document.body.appendChild(wrap);
    var $ = function (sel) { return wrap.querySelector(sel); };
    var msg = $('[data-pzfix-msg]');
    try { $('[data-pzfix-key]').value = sessionStorage.getItem('fcAdminKey') || ''; } catch (e) {}
    setTimeout(function () { try { $('[data-pzfix-order]').focus(); } catch (e) {} }, 30);
    $('[data-pzfix-cancel]').addEventListener('click', function () { wrap.remove(); });
    $('[data-pzfix-go]').addEventListener('click', function () {
      var order = ($('[data-pzfix-order]').value || '').trim().toUpperCase();
      var key = $('[data-pzfix-key]').value || '';
      if (!/^FC\d+$/.test(order)) { msg.textContent = 'Order should look like FC368092'; return; }
      if (!key) { msg.textContent = 'Password required'; return; }
      msg.textContent = 'Attaching…';
      fetch('https://hub.funcases.com/api/router/design-fix', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-admin-key': key },
        body: JSON.stringify({ order: order, print: printUrl, preview: previewUrl })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (res.ok && res.j.ok) {
            try { sessionStorage.setItem('fcAdminKey', key); } catch (e) {}
            msg.style.color = '#137a3f';
            msg.textContent = 'Attached to ' + res.j.order + ' — see the order\'s Additional details.';
            setTimeout(function () { wrap.remove(); }, 2200);
          } else {
            try { sessionStorage.removeItem('fcAdminKey'); } catch (e) {}
            msg.style.color = '#c0392b';
            msg.textContent = 'Failed: ' + (res.j.error || 'unknown');
          }
        }).catch(function (e) { msg.style.color = '#c0392b'; msg.textContent = 'Failed: ' + e.message; });
    });
  }
  if (PZ_EDIT) {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(function () {
        open();
        var tryLoad = function (attempts) {
          if (!fcanvas) { if (attempts > 0) setTimeout(function () { tryLoad(attempts - 1); }, 500); return; }
          fetch('https://res.cloudinary.com/' + CFG.cloudName + '/raw/upload/' + PZ_EDIT)
            .then(function (r) { return r.json(); })
            .then(function (state) {
              restoring = true;
              fcanvas.loadFromJSON(state, function () {
                restoring = false;
                fcanvas.requestRenderAll();
                snapshot();
                hint('ADMIN EDIT — fix the design, then Save to attach it to the order');
              });
            }).catch(function () { hint('Could not load the saved design state'); });
        };
        setTimeout(function () { tryLoad(10); }, 2500);   // after the entry/board finishes applying
      }, 800);
    });
  }

  // Colour Sides is a line-item PROPERTY, not a variant option, so product.js's unsaved-design
  // guard (which keys off input[data-opt-pos]) never sees it — yet it selects the PLATE, and the
  // plates genuinely differ: on iPhone 17 Pro / Pro Max / Air and Pixel 10 the M5 (Black) print
  // area starts below the camera bar while M3 (Clear) prints the whole back. Before this, a design
  // made on Black and then switched to Clear kept the Black clip and exported the Black print rect
  // (order FC366269). Nothing re-ran, because the plate is only chosen when the editor opens.
  // No design attached = nothing to do: the next open re-applies the plate on its own, and
  // re-clipping a hidden canvas would run fitBoard() against a zero-size board.
  var pzSideSyncing = false;
  document.addEventListener('change', function (e) {
    if (pzSideSyncing) return;
    var r = e.target && e.target.closest && e.target.closest('input[name="properties[Colour Sides]"]');
    if (!r || !CFG.isPhone || !CFG.caseMasks || !designAttached) return;
    var mk = maskEntryForSelection();
    if (!mk || !pzPlateSrc || mk.mask === pzPlateSrc) return;   // same plate either way — let it through
    // The print file is already uploaded and cut to the OLD plate, so it cannot simply be
    // re-clipped — the design has to be redone. Revert first, then ask, exactly as product.js does.
    var back = pzPlateSide && document.querySelector('input[name="properties[Colour Sides]"][data-side="' + pzPlateSide + '"]');
    pzSideSyncing = true;
    if (back) { back.checked = true; back.dispatchEvent(new Event('change', { bubbles: true })); }
    pzSideSyncing = false;
    confirmReset(function () {
      pzSideSyncing = true;
      r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true }));
      pzSideSyncing = false;
    });
  });

  /* ---------- boot ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pz-remove]')) { e.preventDefault(); clearDesign(); return; }
    if (e.target.closest('[data-pz-open]')) { e.preventDefault(); open(); }
  });

  // Exposed so the PDP variant/model pickers can warn before wiping an unsaved design.
  window.FCPz = {
    hasDesign: function () { return designAttached; },
    clearDesign: clearDesign,
    confirmReset: confirmReset
  };
})();


/* v2 cache-bump */
